import React, { useState, useRef, useEffect } from "react";
import {
	Home,
	Search,
	ChevronDown,
	ChevronRight,
	Edit2,
	Plus,
	X,
	BarChart3,
	Check,
	Download,
	Users,
	Archive,
	HardDrive,
	Mail,
	History,
	FolderOpen,
	FileText,
} from "lucide-react";
import { CraftButton } from "@craft-design-system/core-components-react";
import Header from "../components/Headers/Header";
import VFFDataTable from "../components/Datatables/VFFDataTable";
import VFFSidebar from "../components/Sidebars/VFFSidebar";
import VFFJoyrideTour from "../components/JoyrideTours/VFFJoyrideTour";
import ExportModal from "../components/Modals/ExportModal";
import VFFExportEmailModal from "../components/Modals/VFFExportEmailModal";
import VFFBulkEditModal from "../components/Modals/VFFBulkEditModal";
import DatabaseExportModal from "../components/Modals/DatabaseExportModal";
import ReminderEmailModal from "../components/Modals/ReminderEmailModal";
import EmailHistoryModal from "../components/Modals/EmailHistoryModal";
import BOMHistoryModal from "../components/Modals/BOMHistoryModal";
import ManualTrackingModal from "../components/Modals/ManualTrackingModal";
import { Box, CircularProgress, Typography } from "@mui/material";
import _ from "lodash";
import { getApiBaseUrl } from "../utils/apiConfig";
import { apiClient } from "../services/api";
import {
	shouldShowTour,
	markTourCompleted,
	PAGE_NAMES,
} from "../utils/firstTimeVisit";
import { isUserAuthorizedForResponsibleFields, signOut } from "../utils/authorizationUtils";

const VFFPage = ({ user }) => {
	// Add CSS for spinner animation
	useEffect(() => {
		document.title = "MAN PTT - Vehicle Tracking";
	}, []);
	useEffect(() => {
		const style = document.createElement("style");
		style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
	const [selectedProgramm, setSelectedProgramm] = useState([]);
	const [selectedProjectNumber, setSelectedProjectNumber] = useState([]);
	const [selectedViewType, setSelectedViewType] = useState("Prototype");
	const [selectedFzgNr, setSelectedFzgNr] = useState([]);
	const [selectedBza, setSelectedBza] = useState([]);
	const [selectedPartNo, setSelectedPartNo] = useState([]); // New Part No filter state
	const [selectedPartNoPrefix, setSelectedPartNoPrefix] = useState([]); // New Part No Prefix filter state
	const [selectedSupplier, setSelectedSupplier] = useState([]); // New Supplier filter state
	const [selectedBaukastenNo, setSelectedBaukastenNo] = useState([]); // Baukasten No filter state
	const [selectedPurchasing, setSelectedPurchasing] = useState([]);
	const [selectedLogistics1, setSelectedLogistics1] = useState([]);
	const [selectedLogistics2, setSelectedLogistics2] = useState([]);
	const [selectedResponsibleParts, setSelectedResponsibleParts] = useState([]);
	const [selectedResponsibleVehicle, setSelectedResponsibleVehicle] = useState(
		[],
	);
	const [selectedPartsStatus, setSelectedPartsStatus] = useState([]);
	const [selectedVehicleStatus, setSelectedVehicleStatus] = useState([]);
	const [selectedAmpelTeilenanflug, setSelectedAmpelTeilenanflug] = useState(
		[],
	);
	const [selectedStatusBtt, setSelectedStatusBtt] = useState([]); // BTT Status filter
	const [selectedKategorieTeilenanflug, setSelectedKategorieTeilenanflug] =
		useState([]);
	const [selectedRuckmeldeStat, setSelectedRuckmeldeStat] = useState([]);
	const [selectedAlg, setSelectedAlg] = useState([]);
	const [selectedSeTeam, setSelectedSeTeam] = useState([]);
	const [selectedMbKey, setSelectedMbKey] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [selectedPet, setSelectedPet] = useState({ from: "", to: "" });
	const [selectedChangeNo, setSelectedChangeNo] = useState([]);
	const [selectedKastKeyAnlage, setSelectedKastKeyAnlage] = useState([]);
	const [selectedAnlo, setSelectedAnlo] = useState([]);
	const [selectedVkgrArt, setSelectedVkgrArt] = useState([]);
	const [selectedBenenn, setSelectedBenenn] = useState([]);
	const [selectedVkgrBend, setSelectedVkgrBend] = useState([]);
	const [selectedFlagging, setSelectedFlagging] = useState([]);
	const [selectedArchive, setSelectedArchive] = useState([]);
	const [isArchivedPartsMode, setIsArchivedPartsMode] = useState(false);

	// Date filter states
	const [selectedRequirementDateFrom, setSelectedRequirementDateFrom] =
		useState(null);
	const [selectedRequirementDateTo, setSelectedRequirementDateTo] =
		useState(null);
	const [selectedPartsFollowupDateFrom, setSelectedPartsFollowupDateFrom] =
		useState(null);
	const [selectedPartsFollowupDateTo, setSelectedPartsFollowupDateTo] =
		useState(null);
	const [selectedLtbDateFrom, setSelectedLtbDateFrom] = useState(null);
	const [selectedLtbDateTo, setSelectedLtbDateTo] = useState(null);
	const [searchQuery, setSearchQuery] = useState("");
	const [searchInput, setSearchInput] = useState("");
	const [itemsPerPage, setItemsPerPage] = useState(25); // Default to 25 to match VFFDataTable default
	const [isBulkEditOpen, setIsBulkEditOpen] = useState(false);
	const [selectedItems, setSelectedItems] = useState([]);
	const [allSelected, setAllSelected] = useState(false);
	const [showFilterTooltip, setShowFilterTooltip] = useState(false);
	const [rows, setRows] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [columns, setColumns] = useState([
		{ field: "id", headerName: "ID", width: 100 },
		{ field: "name", headerName: "Name", width: 200 },
	]);
	const [filterOptions, setFilterOptions] = useState({
		projects: [],
		fzgNr: [],
		bza: [],
	});
	const [editOptions, setEditOptions] = useState({
		projects: [],
		fzgNr: [],
		bza: [],
		suppliers: [],
		total_req: [],
	}); // States for bulk edit/save functionality for responsible fields
	const [isEditMode, setIsEditMode] = useState(false);
	const [editedItems, setEditedItems] = useState({});
	const [isSaving, setIsSaving] = useState(false);
	const [isExporting, setIsExporting] = useState(false); // Add export loading state
	const [isExportModalOpen, setIsExportModalOpen] = useState(false); // Add export modal state (legacy)
	const [isVFFExportEmailModalOpen, setIsVFFExportEmailModalOpen] =
		useState(false); // New email-export modal
	const [isDatabaseExportModalOpen, setIsDatabaseExportModalOpen] =
		useState(false); // Add database export modal state
	const [isReminderEmailModalOpen, setIsReminderEmailModalOpen] =
		useState(false); // Add reminder email modal state
	const [isEmailHistoryModalOpen, setIsEmailHistoryModalOpen] = useState(false); // Add email history modal state
	const [isBOMHistoryModalOpen, setIsBOMHistoryModalOpen] = useState(false); // Add BOM history modal state
	const [isManualTrackingModalOpen, setIsManualTrackingModalOpen] =
		useState(false); // Add manual tracking modal state
	// Bulk edit modal states
	const [isBulkEditModalOpen, setIsBulkEditModalOpen] = useState(false);
	const [selectedItemsForBulkEdit, setSelectedItemsForBulkEdit] = useState([]); // Store selected items for bulk edit

	// Processing progress state for bulk operations
	const [processingProgress, setProcessingProgress] = useState(null);

	const dataTableRef = useRef();
	const sidebarRef = useRef();

	// Tour state
	const [isTourOpen, setIsTourOpen] = useState(false);
	// Flag to track if we've applied dashboard filters
	const [dashboardFiltersApplied, setDashboardFiltersApplied] = useState(false);

	// Loading state for dashboard filter application
	const [isDashboardFilterLoading, setIsDashboardFilterLoading] =
		useState(false);

	// Email view mode: when user arrives via reminder email link, lock to those kast_keys
	const [emailViewKastKeys, setEmailViewKastKeys] = useState([]);

	// Function to navigate to dashboard with VFF view
	const navigateToDashboard = () => {
		window.location.href = "/dashboard?view=vff";
	}; // Get user display name function
	const getUserDisplayName = () => {
		if (user?.profile?.preferred_username) {
			return user.profile.preferred_username;
		}
		if (user?.profile?.email) {
			return user.profile.email.split("@")[0]; // For display, show just username
		}
		return "User";
	}; // Get full user email for authorization
	const getUserEmail = () => {
		if (user?.profile?.email) {
			return user.profile.email; // Return full email
		}
		if (
			user?.profile?.preferred_username &&
			user.profile.preferred_username.includes("@")
		) {
			return user.profile.preferred_username; // If preferred_username is an email
		}
		// Fallback to localStorage username if it contains an email
		const localStorageUsername = localStorage.getItem("username");
		if (localStorageUsername && localStorageUsername.includes("@")) {
			return localStorageUsername;
		}

		// Check if preferred_username is just the username part (like 'yash.sakhare')
		if (user?.profile?.preferred_username) {
			const username = user.profile.preferred_username;
			// If it looks like it could be the first part of your email
			if (username === "yash.sakhare" || username.startsWith("yash.sakhare")) {
				return "yash.sakhare@man.eu";
			}
			if (
				username === "vishal.talwar" ||
				username.startsWith("vishal.talwar")
			) {
				return "vishal.talwar@man.eu";
			}
			if (
				username === "anuradha.shukla" ||
				username.startsWith("anuradha.shukla")
			) {
				return "anuradha.shukla@man.eu";
			}
		}
		return null;
	};

	// Check if user is authorized for database export
	const isUserAuthorizedForDatabaseExport =
		isUserAuthorizedForResponsibleFields(getUserEmail);
	// Function to parse URL parameters and apply dashboard filters
	const applyDashboardFilters = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const vehicleFilter = urlParams.get("vehicle_filter");
		const statusColorFilter = urlParams.get("status_color_filter");
		const purchaseTypeFilter = urlParams.get("purchase_type_filter");
		const partNoPrefixFilter = urlParams.get("part_no_prefix");
		const dateFilter = urlParams.get("date_filter");
		const fromDashboard = urlParams.get("from_dashboard");
		const kastKeysFilter = urlParams.get("kast_keys"); // Handle email reminder view with specific kast_keys
		if (kastKeysFilter && !dashboardFiltersApplied) {
			console.log(
				"Applying kast_keys filter from email reminder:",
				kastKeysFilter,
			);

			const parsedKastKeys = kastKeysFilter
				.split(",")
				.map((k) => k.trim())
				.filter(Boolean);

			// Store the kast_keys so every subsequent filter request is scoped to these records
			setEmailViewKastKeys(parsedKastKeys);

			// Show loading overlay while applying filters
			setIsDashboardFilterLoading(true);

			// Mark that we've applied these filters to prevent reapplication
			setDashboardFiltersApplied(true);

			// Apply the kast_keys filter through the data table
			setTimeout(() => {
				if (dataTableRef.current && dataTableRef.current.fetchData) {
					const filters = {
						programm: [],
						projectNumber: [],
						fzgNr: [],
						bza: [],
						purchasing: [],
						logistics1: [],
						logistics2: [],
						responsibleParts: [],
						responsibleVehicle: [],
						partsStatus: [],
						vehicleStatus: [],
						statusColor: [],
						kategorieTeilenanflug: [],
						ruckmeldeStat: [],
						alg: [],
						globalSearch: "",
						kastKeys: parsedKastKeys,
					};

					console.log(
						"Applying kast_keys filter to VFF table (email view mode):",
						filters,
					);

					// Fetch data and hide loading overlay when complete
					const fetchPromise = dataTableRef.current.fetchData(
						filters,
						1,
						itemsPerPage,
					);

					if (fetchPromise && typeof fetchPromise.then === "function") {
						fetchPromise
							.then(() => {
								setIsDashboardFilterLoading(false);
							})
							.catch((error) => {
								console.error("Error applying kast_keys filter:", error);
								setIsDashboardFilterLoading(false);
							});
					} else {
						setTimeout(() => setIsDashboardFilterLoading(false), 2000);
					}
				} else {
					setIsDashboardFilterLoading(false);
				}
			}, 1000);

			// Clear URL parameters to clean up the URL
			window.history.replaceState({}, document.title, window.location.pathname);
			return; // Exit early since we handled the kast_keys case
		}

		if (
			fromDashboard === "true" &&
			vehicleFilter &&
			statusColorFilter &&
			!dashboardFiltersApplied
		) {
			console.log("Applying dashboard filters:", {
				vehicleFilter,
				statusColorFilter,
				purchaseTypeFilter,
				partNoPrefixFilter,
				dateFilter,
			});

			// Show loading overlay while applying filters
			setIsDashboardFilterLoading(true);
			// Set the vehicle filter
			setSelectedFzgNr([vehicleFilter]);

			// Set the status color filter state for UI display
			setSelectedAmpelTeilenanflug([statusColorFilter]); // Set the purchase type filter state for UI display
			if (purchaseTypeFilter) {
				setSelectedBza(purchaseTypeFilter.split(","));
			}

			// Mark that we've applied these filters to prevent reapplication
			setDashboardFiltersApplied(true);

			// Apply the filters through the data table
			setTimeout(() => {
				if (dataTableRef.current && dataTableRef.current.fetchData) {
					const filters = {
						programm: [],
						projectNumber: [],
						fzgNr: [vehicleFilter],
						bza: purchaseTypeFilter ? purchaseTypeFilter.split(",") : [],
						partNoPrefix: partNoPrefixFilter
							? partNoPrefixFilter.split(",")
							: [], // Add part number prefix filter
						purchasing: [],
						logistics1: [],
						logistics2: [],
						responsibleParts: [],
						responsibleVehicle: [],
						partsStatus: [],
						vehicleStatus: [],
						statusColor: [statusColorFilter],
						kategorieTeilenanflug: [],
						ruckmeldeStat: [],
						alg: [],
						// Add traffic_light filter for dashboard redirects
						trafficLight: ["Total"], // Filter by traffic_light = 'Total'
						globalSearch: "", // Keep search empty
					};

					// Add date filtering if provided (use requirement date range)
					if (dateFilter) {
						// Set both from and to date to the same date for exact match
						const dateObj = new Date(dateFilter);
						if (!isNaN(dateObj.getTime())) {
							filters.requirementDateFrom = dateObj.toISOString();
							filters.requirementDateTo = dateObj.toISOString();
						}
					}

					console.log(
						"Applying dashboard filters to VFF table (dedicated ampel filtering):",
						filters,
					);

					// Fetch data and hide loading overlay when complete
					const fetchPromise = dataTableRef.current.fetchData(
						filters,
						1,
						itemsPerPage,
					);

					// Handle both promise and non-promise returns
					if (fetchPromise && typeof fetchPromise.then === "function") {
						fetchPromise
							.then(() => {
								setIsDashboardFilterLoading(false);
								// Reset dashboard filter flag to allow normal operations
								if (
									dataTableRef.current &&
									dataTableRef.current.resetDashboardFilterFlag
								) {
									dataTableRef.current.resetDashboardFilterFlag();
								}
							})
							.catch((error) => {
								console.error("Error applying dashboard filters:", error);
								setIsDashboardFilterLoading(false);
								// Reset dashboard filter flag even on error
								if (
									dataTableRef.current &&
									dataTableRef.current.resetDashboardFilterFlag
								) {
									dataTableRef.current.resetDashboardFilterFlag();
								}
							});
					} else {
						// Fallback if fetchData doesn't return a promise
						setTimeout(() => {
							setIsDashboardFilterLoading(false);
							// Reset dashboard filter flag to allow normal operations
							if (
								dataTableRef.current &&
								dataTableRef.current.resetDashboardFilterFlag
							) {
								dataTableRef.current.resetDashboardFilterFlag();
							}
						}, 2000);
					}
				} else {
					// Fallback to hide loading if data table ref is not available
					setIsDashboardFilterLoading(false);
				}
			}, 1000); // Delay to ensure component is fully loaded

			// Clear URL parameters to clean up the URL
			window.history.replaceState({}, document.title, window.location.pathname);
		}
	};

	// Effect to synchronize with dataTableRef's itemsPerPage when it changes
	useEffect(() => {
		if (dataTableRef.current) {
			// Set up a method that the child component can call to update parent's itemsPerPage
			dataTableRef.current.setParentItemsPerPage = (newPerPage) => {
				console.log("VFFPage: Updating items per page from child:", newPerPage);
				setItemsPerPage(newPerPage);
			};
		}
	}, [dataTableRef]);

	// Check for dashboard filters after component mounts
	useEffect(() => {
		// Apply dashboard filters after a short delay to ensure components are loaded
		setTimeout(applyDashboardFilters, 500);
	}, [dashboardFiltersApplied]);

	// Check if tour should continue from landing page OR if this is first time visiting VFF
	useEffect(() => {
		const continueVFFTour = localStorage.getItem("continueVFFTour");
		const isFirstTimeVisit = shouldShowTour(PAGE_NAMES.VFF);

		if (continueVFFTour === "true") {
			// (Kept for backward-compatibility; the landing page no longer sets this
			// flag.) Start the tour immediately.
			localStorage.removeItem("continueVFFTour");
			setIsTourOpen(true);
			markTourCompleted(PAGE_NAMES.VFF);
		} else if (isFirstTimeVisit) {
			// First time visiting VFF page directly
			const timer = setTimeout(() => {
				setIsTourOpen(true);
				markTourCompleted(PAGE_NAMES.VFF);
			}, 1000);
			return () => clearTimeout(timer);
		}
	}, []);
	// Bulk edit state
	const [bulkEditValues, setBulkEditValues] = useState({
		programm: "",
		fzgNr: "",
		bza: "",
		supplier: "",
		total_req: "",
		archive: "",
	});

	// Handle bulk edit value changes
	const handleBulkEditChange = (field, value) => {
		setBulkEditValues((prev) => ({
			...prev,
			[field]: value,
		}));
	}; // Handle bulk save for responsible and date fields
	const handleBulkSave = async () => {
		if (!isEditMode || Object.keys(editedItems).length === 0) return;

		setIsSaving(true);
		try {
			// Prepare bulk update payload
			const updates = Object.entries(editedItems).map(([kastKey, changes]) => ({
				kast_key: kastKey,
				updates: changes,
			}));
			console.log(
				"Performing bulk update for responsible, date, and flagging fields:",
				updates,
			); // Add user information to headers for tracking
			const headers = {
				"X-User-Name": getUserEmail() || "Unknown User",
			};

			// Call the comprehensive bulk update API (handles all field types including flagging)
			const response = await apiClient.post(
				"/api/bulk-update-comprehensive",
				{
					updates,
					user_name: getUserEmail() || "Unknown User",
				},
				{ headers },
			);
			if (response.data.success) {
				console.log("✅ Bulk update successful:", response.data);

				// Update local state in the data table to reflect changes immediately
				if (dataTableRef.current?.updateLocalDataFromEditMode) {
					dataTableRef.current.updateLocalDataFromEditMode(editedItems);
				}

				// Clear edited items and exit edit mode
				setEditedItems({});
				setIsEditMode(false);

				// Don't refresh the data table to prevent page refresh and maintain scroll position
				// The backend bulk update already updates the database, no need to fetch fresh data
				console.log(
					"✅ Bulk update completed without page refresh - maintaining user scroll position",
				);
			} else {
				throw new Error(response.data.message || "Bulk update failed");
			}
		} catch (error) {
			console.error("❌ Error performing bulk update:", error);
			let errorMessage = "Failed to save changes. Please try again.";

			if (error.response?.data?.detail) {
				errorMessage = error.response.data.detail;
			} else if (error.message) {
				errorMessage = error.message;
			}
			alert(errorMessage);
		} finally {
			setIsSaving(false);
		}
	}; // Bulk edit modal handlers
	const handleOpenBulkEditModal = () => {
		// Get selected items from the data table
		if (selectedItems.length < 1) {
			alert("Please select at least 1 item to bulk edit.");
			return;
		}
		if (selectedItems.length > 100) {
			alert(
				`Bulk edit is limited to 100 records at a time. You have selected ${selectedItems.length} records. Please deselect some items and try again.`,
			);
			return;
		}

		// Get fresh data for selected items from the current rows state
		const freshSelectedItems = selectedItems.map((selectedItem) => {
			// Find the corresponding item in the current rows state to get fresh data
			const freshRowData = rows.find(
				(row) => row.kast_key === selectedItem.kast_key,
			);
			if (freshRowData) {
				// Return the fresh data but keep the selected item's ID for consistency
				return {
					...freshRowData,
					id: selectedItem.id, // Keep the original ID for selection consistency
				};
			}
			// Fallback to the original selected item if not found in rows (shouldn't happen)
			return selectedItem;
		});

		console.log(
			"🔄 Opening bulk edit with fresh data for",
			freshSelectedItems.length,
			"items",
		);
		setSelectedItemsForBulkEdit(freshSelectedItems);
		setIsBulkEditModalOpen(true);
	};
	const handleCloseBulkEditModal = () => {
		setIsBulkEditModalOpen(false);
		setSelectedItemsForBulkEdit([]);
	};
	// Archived parts handler
	const handleArchivedPartsToggle = async () => {
		let newArchiveFilter = [];
		let newArchivedPartsMode = false;

		if (isArchivedPartsMode) {
			// Exit archived parts mode - clear the archive filter
			newArchiveFilter = [];
			newArchivedPartsMode = false;
		} else {
			// Enter archived parts mode - set archive filter to all except "Unarchived"
			newArchiveFilter = [
				"To be deleted",
				"Duplicate Entry",
				"No Demand",
				"Hausteile",
				"On Hold",
				"PAT",
				"Others",
			];
			newArchivedPartsMode = true;
		}

		// Update state
		setSelectedArchive(newArchiveFilter);
		setIsArchivedPartsMode(newArchivedPartsMode);

		// Build the complete filters object with the new archive filter
		const updatedFilters = {
			programm: selectedProgramm,
			projectNumber: selectedProjectNumber,
			fzgNr: selectedFzgNr,
			bza: selectedBza,
			partNo: selectedPartNo,
			partNoPrefix: selectedPartNoPrefix,
			supplier: selectedSupplier,
			purchasing: selectedPurchasing,
			logistics1: selectedLogistics1,
			logistics2: selectedLogistics2,
			responsibleParts: selectedResponsibleParts,
			responsibleVehicle: selectedResponsibleVehicle,
			partsStatus: selectedPartsStatus,
			vehicleStatus: selectedVehicleStatus,
			statusColor: selectedAmpelTeilenanflug,
			statusBtt: selectedStatusBtt,
			kategorieTeilenanflug: selectedKategorieTeilenanflug,
			ruckmeldeStat: selectedRuckmeldeStat,
			vkgrArt: selectedVkgrArt,
			benenn: selectedBenenn,
			vkgrBend: selectedVkgrBend,
			alg: selectedAlg,
			pet: selectedPet,
			se_team: selectedSeTeam,
			changeNo: selectedChangeNo,
			kastKeyAnlage: selectedKastKeyAnlage,
			anlo: selectedAnlo,
			flagging: selectedFlagging,
			archive: newArchiveFilter,
			globalSearch: searchQuery,
		};

		// Trigger data fetch with updated filters
		try {
			setIsLoading(true);

			// Get the current itemsPerPage from the data table component if available
			let currentItemsPerPage = itemsPerPage;
			if (
				dataTableRef.current &&
				typeof dataTableRef.current.getCurrentItemsPerPage === "function"
			) {
				const dataTableItemsPerPage =
					dataTableRef.current.getCurrentItemsPerPage();
				if (dataTableItemsPerPage) {
					currentItemsPerPage = dataTableItemsPerPage;
					if (currentItemsPerPage !== itemsPerPage) {
						setItemsPerPage(currentItemsPerPage);
					}
				}
			}

			// Call the fetchData method of the dataTableRef with updated filters
			if (dataTableRef.current && dataTableRef.current.fetchData) {
				console.log("Applying archived parts filter:", newArchiveFilter);

				// Set flag to prevent useEffect from triggering duplicate fetch
				if (dataTableRef.current.setStateTriggerFlag) {
					dataTableRef.current.setStateTriggerFlag(true);
				}

				await dataTableRef.current.fetchData(
					updatedFilters,
					1,
					currentItemsPerPage,
				);
			}
		} catch (error) {
			console.error("Error applying archived parts filter:", error);
		} finally {
			setIsLoading(false);
		}
	};
	const handleBulkEditSave = async (selectedItems, changes) => {
		if (
			!selectedItems ||
			selectedItems.length === 0 ||
			!changes ||
			Object.keys(changes).length === 0
		) {
			alert("No items selected or no changes to apply.");
			return;
		}

		setIsSaving(true);
		setProcessingProgress({
			current: 0,
			total: selectedItems.length,
			currentOperation: "Sending updates to server…",
		});

		try {
			// Build the comprehensive payload
			const updates = selectedItems.map((item) => ({
				kast_key: item.kast_key,
				updates: changes,
			}));

			const payload = {
				updates,
				user_name: changes.user_name || "Unknown User",
			};

			// Pick the right endpoint
			let apiEndpoint = "/api/bulk-update-comprehensive";
			if (changes.ltb_date && Object.keys(changes).length === 1) {
				apiEndpoint = "/api/bulk-update-ltb";
				payload.updates = updates.map((u) => ({
					kast_key: u.kast_key,
					ltb: changes.ltb_date,
				}));
			} else if (changes.status_btt && Object.keys(changes).length === 1) {
				apiEndpoint = "/api/bulk-update-btt-status";
				payload.updates = updates.map((u) => ({
					kast_key: u.kast_key,
					status_btt: changes.status_btt,
				}));
			}

			setProcessingProgress({
				current: Math.floor(selectedItems.length * 0.5),
				total: selectedItems.length,
				currentOperation: `Updating ${selectedItems.length} record(s)…`,
			});

			const headers = { "X-User-Name": getUserEmail() || "Unknown User" };
			const response = await apiClient.post(apiEndpoint, payload, { headers });

			if (response.data.success) {
				setProcessingProgress({
					current: selectedItems.length,
					total: selectedItems.length,
					currentOperation: "Applying changes…",
				});

				// ── Patch rows in-place — scroll position is fully preserved ──────────
				if (dataTableRef.current?.updateLocalData) {
					dataTableRef.current.updateLocalData(selectedItems, changes);
				}

				// Clear selections and close modal
				setSelectedItems([]);
				setAllSelected(false);
				if (dataTableRef.current?.clearAllSelections) {
					dataTableRef.current.clearAllSelections();
				}
				handleCloseBulkEditModal();

				console.log(
					`✅ Bulk edit: ${selectedItems.length} items patched in-place, scroll preserved.`,
				);
			} else {
				throw new Error(response.data.message || "Bulk edit failed");
			}
		} catch (error) {
			console.error("❌ Error performing bulk edit:", error);
			const errorMessage =
				error.response?.data?.detail ||
				error.message ||
				"Failed to apply bulk changes. Please try again.";
			alert(errorMessage);
		} finally {
			setIsSaving(false);
			setProcessingProgress(null);
		}
	};

	// Tour handlers
	const handleStartTour = () => {
		setIsTourOpen(true);
	};
	const handleCloseTour = () => {
		setIsTourOpen(false);
		// Ensure the page is marked as visited when tour is closed
		markTourCompleted(PAGE_NAMES.VFF);
	};

	// Exit email view mode and reload full dataset
	const handleExitEmailView = async () => {
		setEmailViewKastKeys([]);
		if (dataTableRef.current && dataTableRef.current.fetchData) {
			const emptyFilters = {
				programm: [],
				projectNumber: [],
				fzgNr: [],
				bza: [],
				partNo: [],
				partNoPrefix: [],
				supplier: [],
				baukastenNo: [],
				purchasing: [],
				logistics1: [],
				logistics2: [],
				responsibleParts: [],
				responsibleVehicle: [],
				partsStatus: [],
				vehicleStatus: [],
				statusColor: [],
				statusBtt: [],
				kategorieTeilenanflug: [],
				ruckmeldeStat: [],
				alg: [],
				seTeam: [],
				vkgrArt: [],
				benenn: [],
				vkgrBend: [],
				flagging: [],
				archive: [],
				globalSearch: "",
			};
			await dataTableRef.current.fetchData(emptyFilters, 1, itemsPerPage);
		}
	};

	const [columnVisibility, setColumnVisibility] = useState({
		rampUpGroup: true,
		seTeams: true,
		purchaseType: true,
		gxClassification: true,
		supplier: true,
	});

	const handleColumnVisibilityChange = (newVisibility) => {
		setColumnVisibility(newVisibility);
	}; // Handle updates from dropdowns in the data table
	const handleUpdateItem = async (id, field, value, kastKey) => {
		// VFFDataTable already handles the API call and state updates
		// This function is kept for compatibility but no longer makes duplicate API calls
		console.log(
			`✅ Field ${field} updated for item ${id} - handled by VFFDataTable`,
		);
	};

	const handleSelectItems = (items) => {
		// Ensure we have consistent IDs for all items
		const processedItems = items.map((item) => ({
			...item,
			id: item.id || item.vehicle_no + item.part_no, // Ensure we have a unique identifier
		}));

		setSelectedItems(processedItems);

		// Check if all items on the current page are selected
		const currentPageData = dataTableRef.current?.getCurrentPageData?.() || [];
		const currentPageIds = new Set(
			currentPageData.map((item) => item.id || item.vehicle_no + item.part_no),
		);
		const selectedIds = new Set(processedItems.map((item) => item.id));

		const allPageItemsSelected =
			currentPageData.length > 0 &&
			currentPageData.every((item) => {
				const itemId = item.id || item.vehicle_no + item.part_no;
				return selectedIds.has(itemId);
			});

		setAllSelected(allPageItemsSelected);
	};

	const fontStyles = {
		regular: {
			fontFamily: "MAN EUROPE_Regular, Arial, sans-serif",
		},
		bold: {
			fontFamily: "MAN EUROPE_Bold, Arial, sans-serif",
		},
	};
	const styles = {
		mainContainer: {
			display: "flex",
			flexDirection: "column",
			height: "100vh",
			width: "100vw",
			paddingTop: "calc(74px + var(--banner-height, 0px))",
			boxSizing: "border-box",
			backgroundColor: "white",
			overflow: "hidden",
			...fontStyles.regular,
		},
		contentWrapper: {
			display: "flex",
			flex: 1,
			overflow: "hidden",
			padding: "0 0px 0px 0px",
		},
		mainContent: {
			flex: 1,
			overflow: "hidden",
			backgroundColor: "white",
			marginLeft: "0px",
			display: "flex",
			flexDirection: "column",
		},
		tableContainer: {
			flex: 1,
			overflow: "auto",
			padding: "0px",
			width: "100%",
			display: "flex",
			flexDirection: "column",
			minHeight: 0,
		},
		searchContainer: {
			padding: "10px 0px 5px 0px",
			backgroundColor: "#f1f1f1",
			borderBottom: "1px solid #eee",
			width: "100%",
		},
		modal: {
			position: "fixed",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: "rgba(0, 0, 0, 0.5)",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			zIndex: 1000,
		},
		modalContent: {
			backgroundColor: "white",
			width: "90%",
			maxWidth: "1200px",
			maxHeight: "90vh",
			display: "flex",
			flexDirection: "column",
			boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
		},
		modalHeader: {
			padding: "0px 20px",
			borderBottom: "1px solid #eee",
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			backgroundColor: "#f5f5f5",
		},
		modalBody: {
			padding: "15px 10px",
			overflowY: "auto",
			flex: 1,
		},
		modalFooter: {
			padding: "10px 20px",
			borderTop: "1px solid #eee",
			display: "flex",
			justifyContent: "flex-end",
			gap: "10px",
			backgroundColor: "#f5f5f5",
		},
		table: {
			width: "100%",
			borderCollapse: "collapse",
			marginBottom: "20px",
		},
		tableHeader: {
			...fontStyles.bold,
			padding: "12px",
			textAlign: "left",
			fontSize: "12px",
			color: "#666",
		},
		tableCell: {
			...fontStyles.regular,
			padding: "12px",
			textAlign: "left",
		},
		select: {
			...fontStyles.regular,
			width: "100%",
			padding: "8px",
			border: "1px solid #ddd",
			backgroundColor: "white",
		},
		button: {
			...fontStyles.regular,
			backgroundColor: "#666",
			color: "white",
			border: "none",
			padding: "8px 16px",
			cursor: "pointer",
		},
		label: {
			...fontStyles.regular,
			fontSize: "14px",
			color: "#333",
		},
	};

	const sidebarStyles = {
		container: {
			width: isSidebarCollapsed ? "50px" : "250px",
			backgroundColor: "#f8f8f8",
			padding: 0,
			transition: "all 0.3s ease",
			position: "relative",
			overflow: "hidden",
			padding: "0px 0px 10px 0px",
			borderRight: "2px solid black",
			borderTop: "2px solid black",
			height: "100%",
			...fontStyles.regular,
		},
		header: {
			display: "flex",
			alignItems: "center",
			padding: "15px",
			backgroundColor: "#f8f8f8",
			justifyContent: isSidebarCollapsed ? "center" : "space-between",
		},
		title: {
			...fontStyles.bold,
			fontSize: "16px",
			margin: 0,
			display: "flex",
			alignItems: "center",
		},
		toggleButton: {
			background: "none",
			border: "none",
			cursor: "pointer",
			padding: "4px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: "4px",
			transition: "background-color 0.2s ease",
		},
		content: {
			opacity: isSidebarCollapsed ? 0 : 1,
			visibility: isSidebarCollapsed ? "hidden" : "visible",
			transition: "opacity 0.2s ease",
			width: "100%",
			padding: "15px",
		},
		filterLabel: {
			...fontStyles.regular,
			display: "block",
			fontSize: "14px",
			marginBottom: "6px",
			color: "#333",
		},
		select: {
			...fontStyles.regular,
			width: "90%",
			padding: "8px",
			border: "1px solid #ddd",
			marginBottom: "16px",
			backgroundColor: "white",
			cursor: "pointer",
		},
		filterGroup: {
			marginBottom: "15px",
		},
	};

	useEffect(() => {
		// Initialize editOptions
		setEditOptions({
			projects: [],
			fzgNr: [],
			bza: [],
			suppliers: [],
			total_req: [],
		});
	}, []);
	const handleSidebarToggle = () => {
		setIsSidebarCollapsed(!isSidebarCollapsed);
	};

	const handlePageChange = async (page = 1, perPage = itemsPerPage) => {
		try {
			setIsLoading(true);
			// Create a filters object with current filter states
			const filters = {
				programm: selectedProgramm || [],
				projectNumber: selectedProjectNumber || [],
				fzgNr: selectedFzgNr || [],
				bza: selectedBza || [],
				partNo: selectedPartNo || [],
				supplier: selectedSupplier || [],
				purchasing: selectedPurchasing || [],
				logistics1: selectedLogistics1 || [],
				logistics2: selectedLogistics2 || [],
				responsibleParts: selectedResponsibleParts || [],
				responsibleVehicle: selectedResponsibleVehicle || [],
				partsStatus: selectedPartsStatus || [],
				vehicleStatus: selectedVehicleStatus || [],
				statusColor: selectedAmpelTeilenanflug || [],
				statusBtt: selectedStatusBtt || [],
				kategorieTeilenanflug: selectedKategorieTeilenanflug || [],
				vkgrArt: selectedVkgrArt || [],
				benenn: selectedBenenn || [],
				vkgrBend: selectedVkgrBend || [],
				ruckmeldeStat: selectedRuckmeldeStat || [],
				alg: selectedAlg || [],
				pet: selectedPet || { from: "", to: "" },
				seTeam: selectedSeTeam || [],
				changeNo: selectedChangeNo || [],
				kastKeyAnlage: selectedKastKeyAnlage || [],
				anlo: selectedAnlo || [],
				globalSearch: searchQuery || "",
			};
			// In email view mode, always scope results to the emailed kast_keys
			if (emailViewKastKeys.length > 0) {
				filters.kastKeys = emailViewKastKeys;
			}

			// Call the fetchData method on the dataTable ref
			if (dataTableRef.current && dataTableRef.current.fetchData) {
				await dataTableRef.current.fetchData(filters, page, perPage);
			}
		} finally {
			setIsLoading(false);
		}
	};
	const handleSearch = async (searchQuery) => {
		setSearchQuery(searchQuery);
		try {
			setIsLoading(true);
			if (dataTableRef.current && dataTableRef.current.fetchData) {
				// Create a filters object with the search query to pass to fetchData
				const filters = {
					programm: selectedProgramm,
					projectNumber: selectedProjectNumber,
					fzgNr: selectedFzgNr,
					bza: selectedBza,
					partNo: selectedPartNo,
					partNoPrefix: selectedPartNoPrefix,
					supplier: selectedSupplier,
					purchasing: selectedPurchasing,
					logistics1: selectedLogistics1,
					logistics2: selectedLogistics2,
					responsibleParts: selectedResponsibleParts,
					responsibleVehicle: selectedResponsibleVehicle,
					partsStatus: selectedPartsStatus,
					vehicleStatus: selectedVehicleStatus,
					statusColor: selectedAmpelTeilenanflug || [],
					statusBtt: selectedStatusBtt || [],
					kategorieTeilenanflug: selectedKategorieTeilenanflug || [],
					ruckmeldeStat: selectedRuckmeldeStat,
					vkgrArt: selectedVkgrArt || [],
					benenn: selectedBenenn || [],
					vkgrBend: selectedVkgrBend || [],
					alg: selectedAlg,
					pet: selectedPet,
					changeNo: selectedChangeNo,
					kastKeyAnlage: selectedKastKeyAnlage,
					anlo: selectedAnlo,
					seTeam: selectedSeTeam,
					flagging: selectedFlagging,
					archive: selectedArchive,
					globalSearch: searchQuery,
				};

				// In email view mode, always scope results to the emailed kast_keys
				if (emailViewKastKeys.length > 0) {
					filters.kastKeys = emailViewKastKeys;
				}

				// Call fetchData with the correct parameter order: filters, page, itemsPerPage
				await dataTableRef.current.fetchData(filters, 1, itemsPerPage);
			}
		} finally {
			setIsLoading(false);
		}
	};

	const handleSearchSubmit = (e) => {
		e.preventDefault();
		setCurrentPage(1); // Reset to first page when searching
		handleSearch(searchInput);
	};
	const handleSearchClear = async () => {
		setSearchInput("");
		setSearchQuery("");
		setCurrentPage(1);
		if (dataTableRef.current && dataTableRef.current.fetchData) {
			// Create a filters object with empty search query
			const filters = {
				programm: selectedProgramm,
				projectNumber: selectedProjectNumber,
				fzgNr: selectedFzgNr,
				bza: selectedBza,
				partNo: selectedPartNo,
				partNoPrefix: selectedPartNoPrefix,
				supplier: selectedSupplier,
				purchasing: selectedPurchasing,
				logistics1: selectedLogistics1,
				logistics2: selectedLogistics2,
				responsibleParts: selectedResponsibleParts,
				responsibleVehicle: selectedResponsibleVehicle,
				partsStatus: selectedPartsStatus,
				vehicleStatus: selectedVehicleStatus,
				statusColor: selectedAmpelTeilenanflug || [],
				statusBtt: selectedStatusBtt || [],
				kategorieTeilenanflug: selectedKategorieTeilenanflug || [],
				ruckmeldeStat: selectedRuckmeldeStat,
				alg: selectedAlg,
				pet: selectedPet,
				changeNo: selectedChangeNo,
				kastKeyAnlage: selectedKastKeyAnlage,
				vkgrArt: selectedVkgrArt,
				benenn: selectedBenenn,
				vkgrBend: selectedVkgrBend,
				anlo: selectedAnlo,
				seTeam: selectedSeTeam,
				flagging: selectedFlagging,
				archive: selectedArchive,
				globalSearch: "",
			};

			// In email view mode, always scope results to the emailed kast_keys
			if (emailViewKastKeys.length > 0) {
				filters.kastKeys = emailViewKastKeys;
			}

			// Call fetchData with the correct parameter order: filters, page, itemsPerPage
			await dataTableRef.current.fetchData(filters, 1, itemsPerPage);
		}
	};

	const handleBulkEdit = () => {
		setIsBulkEditOpen(true);
	};

	const handleCloseBulkEdit = () => {
		setIsBulkEditOpen(false);
	};

	const handleSelectItem = (item) => {
		const isSelected = selectedItems.some(
			(selected) => selected.id === item.id,
		);
		if (isSelected) {
			setSelectedItems(
				selectedItems.filter((selected) => selected.id !== item.id),
			);
		} else {
			setSelectedItems([...selectedItems, item]);
		}
	};

	const handleSelectAll = () => {
		if (allSelected) {
			setSelectedItems([]);
		} else {
			setSelectedItems([...rows]);
		}
		setAllSelected(!allSelected);
	};

	const handleItemsPerPageChange = async (newItemsPerPage) => {
		setItemsPerPage(newItemsPerPage);
		try {
			setIsLoading(true);
			const queryParams = new URLSearchParams();
			if (selectedProgramm && selectedProgramm.length > 0) {
				queryParams.append("programm", selectedProgramm[0]);
			}
			queryParams.append("page", 1);
			queryParams.append("items_per_page", newItemsPerPage);
		} finally {
			setIsLoading(false);
		}
	};
	const handleFiltersChange = async (filters, viewType) => {
		console.log("📊 VFFPage receiving filters:", filters);
		console.log("📊 Supplier filter received:", filters.supplier);
		setSelectedProgramm(filters.programm || []);
		setSelectedProjectNumber(filters.projectNumber || []);
		setSelectedFzgNr(filters.fzgNr || []);
		setSelectedBza(filters.bza || []);
		setSelectedPartNo(filters.partNo || []); // New Part No filter
		setSelectedPartNoPrefix(filters.partNoPrefix || []); // New Part No Prefix filter
		setSelectedSupplier(filters.supplier || []); // New Supplier filter
		setSelectedBaukastenNo(filters.baukastenNo || []); // Baukasten No filter

		console.log("📊 Setting selectedSupplier to:", filters.supplier || []);
		setSelectedPurchasing(filters.purchasing || []);
		setSelectedLogistics1(filters.logistics1 || []);
		setSelectedLogistics2(filters.logistics2 || []);
		setSelectedResponsibleParts(filters.responsibleParts || []);
		setSelectedResponsibleVehicle(filters.responsibleVehicle || []);
		setSelectedPartsStatus(filters.partsStatus || []);
		setSelectedVehicleStatus(filters.vehicleStatus || []);
		setSelectedAmpelTeilenanflug(filters.statusColor || []);
		setSelectedStatusBtt(filters.statusBtt || []);
		setSelectedKategorieTeilenanflug(filters.kategorieTeilenanflug || []);
		setSelectedRuckmeldeStat(filters.ruckmeldeStat || []);
		setSelectedAlg(filters.alg || []);
		setSelectedSeTeam(filters.seTeam || []);
		setSelectedMbKey(filters.mbKey || []);
		setSelectedTags(filters.tags || []);
		setSelectedPet(filters.pet || { from: "", to: "" });
		setSelectedChangeNo(filters.changeNo || []);
		setSelectedKastKeyAnlage(filters.kastKeyAnlage || []);
		setSelectedAnlo(filters.anlo || []);
		setSelectedVkgrArt(filters.vkgrArt || []);
		setSelectedBenenn(filters.benenn || []);
		setSelectedVkgrBend(filters.vkgrBend || []);
		setSelectedFlagging(
			filters.flagging !== undefined ? filters.flagging : selectedFlagging,
		);
		// Preserve archive/archivedPartsMode when sidebar doesn't explicitly send an archive filter
		const incomingArchive =
			filters.archive !== undefined ? filters.archive : selectedArchive;
		setSelectedArchive(incomingArchive);
		if (incomingArchive.length === 0) {
			setIsArchivedPartsMode(false);
		}
		setSelectedViewType(viewType);

		// Update date filter states
		setSelectedRequirementDateFrom(filters.requirementDateFrom || null);
		setSelectedRequirementDateTo(filters.requirementDateTo || null);
		setSelectedPartsFollowupDateFrom(filters.partsFollowupDateFrom || null);
		setSelectedPartsFollowupDateTo(filters.partsFollowupDateTo || null);
		setSelectedLtbDateFrom(filters.ltbDateFrom || null);
		setSelectedLtbDateTo(filters.ltbDateTo || null);

		// Update searchQuery if globalSearch is provided in filters
		if (filters.globalSearch !== undefined) {
			setSearchQuery(filters.globalSearch);
			setSearchInput(filters.globalSearch); // Keep UI in sync
		}

		try {
			setIsLoading(true);

			// Get the current itemsPerPage from the data table component if available
			let currentItemsPerPage = itemsPerPage;
			if (
				dataTableRef.current &&
				typeof dataTableRef.current.getCurrentItemsPerPage === "function"
			) {
				const dataTableItemsPerPage =
					dataTableRef.current.getCurrentItemsPerPage();
				if (dataTableItemsPerPage) {
					currentItemsPerPage = dataTableItemsPerPage;
					// Synchronize with parent state if different
					if (currentItemsPerPage !== itemsPerPage) {
						setItemsPerPage(currentItemsPerPage);
					}
				}
			}

			// Call the fetchData method of the dataTableRef with filters
			// Pass the current itemsPerPage to maintain the user's preference
			if (dataTableRef.current && dataTableRef.current.fetchData) {
				console.log(
					"Applying filters:",
					filters,
					"with items per page:",
					currentItemsPerPage,
				);
				const filtersToApply = {
					...filters,
					projectNumber: filters.projectNumber || [],
					partNo: filters.partNo || [],
					partNoPrefix: filters.partNoPrefix || [],
					supplier: filters.supplier || [],
					baukastenNo: filters.baukastenNo || [],
					statusColor: filters.statusColor || [],
					statusBtt: filters.statusBtt || [],
					kategorieTeilenanflug: filters.kategorieTeilenanflug || [],
					seTeam: filters.seTeam || [],
					mbKey: filters.mbKey || [],
					tags: filters.tags || [],
					vkgrArt: filters.vkgrArt || [],
					benenn: filters.benenn || [],
					vkgrBend: filters.vkgrBend || [],
					flagging:
						filters.flagging !== undefined
							? filters.flagging
							: selectedFlagging,
					archive:
						filters.archive !== undefined ? filters.archive : selectedArchive,
					globalSearch:
						filters.globalSearch !== undefined
							? filters.globalSearch
							: searchInput,
				};

				// In email view mode, always scope results to the emailed kast_keys
				if (emailViewKastKeys.length > 0) {
					filtersToApply.kastKeys = emailViewKastKeys;
				}

				// Set flag to prevent useEffect from triggering duplicate fetch
				if (dataTableRef.current.setStateTriggerFlag) {
					dataTableRef.current.setStateTriggerFlag(true);
				}
				// Pass filters object as first parameter, then page number, then items per page
				await dataTableRef.current.fetchData(
					filtersToApply,
					1,
					currentItemsPerPage,
				);
			}
		} catch (error) {
			console.error("Error applying filters:", error);
		} finally {
			setIsLoading(false);
		}
	};
	const handleClearAllFilters = () => {
		// Reset all filter state variables
		setSelectedProgramm([]);
		setSelectedProjectNumber([]);
		setSelectedFzgNr([]);
		setSelectedBza([]);
		setSelectedPartNo([]); // Clear Part No filter
		setSelectedPartNoPrefix([]); // Clear Part No Prefix filter
		setSelectedSupplier([]); // Clear Supplier filter
		setSelectedBaukastenNo([]); // Clear Baukasten No filter
		setSelectedPurchasing([]);
		setSelectedLogistics1([]);
		setSelectedLogistics2([]);
		setSelectedResponsibleParts([]);
		setSelectedResponsibleVehicle([]);
		setSelectedPartsStatus([]);
		setSelectedVehicleStatus([]);
		setSelectedAmpelTeilenanflug([]);
		setSelectedStatusBtt([]);
		setSelectedKategorieTeilenanflug([]);
		setSelectedRuckmeldeStat([]);
		setSelectedAlg([]);
		setSelectedSeTeam([]);
		setSelectedMbKey([]);
		setSelectedTags([]);
		setSelectedPet({ from: "", to: "" });
		setSelectedChangeNo([]);
		setSelectedKastKeyAnlage([]);
		setSelectedAnlo([]);
		setSelectedVkgrArt([]);
		setSelectedBenenn([]);
		setSelectedVkgrBend([]);
		setSelectedFlagging([]);
		setSelectedArchive([]);
		setIsArchivedPartsMode(false);

		// Clear date filter states
		setSelectedRequirementDateFrom(null);
		setSelectedRequirementDateTo(null);
		setSelectedPartsFollowupDateFrom(null);
		setSelectedPartsFollowupDateTo(null);
		setSelectedLtbDateFrom(null);
		setSelectedLtbDateTo(null);

		setSearchInput("");
		setSearchQuery("");
		setSelectedViewType("Prototype");
		setCurrentPage(1);

		// Also clear sidebar state
		if (sidebarRef.current && sidebarRef.current.clearSidebarState) {
			sidebarRef.current.clearSidebarState();
		}
		// Create an empty filters object
		const emptyFilters = {
			programm: [],
			projectNumber: [],
			fzgNr: [],
			bza: [],
			partNo: [],
			partNoPrefix: [],
			supplier: [],
			purchasing: [],
			logistics1: [],
			logistics2: [],
			responsibleParts: [],
			responsibleVehicle: [],
			partsStatus: [],
			vehicleStatus: [],
			statusColor: [],
			kategorieTeilenanflug: [],
			ruckmeldeStat: [],
			alg: [],
			seTeam: [],
			flagging: [], // Initialize flagging filtering (empty for clear)
			archive: [], // Initialize archive filtering (empty for clear)
			vkgrArt: [],
			benenn: [],
			vkgrBend: [],
			globalSearch: "",
		}; // Reset sorting to default state
		if (dataTableRef.current && dataTableRef.current.resetSorting) {
			dataTableRef.current.resetSorting();
		} // Call fetchData with empty filters but maintain the current itemsPerPage
		if (dataTableRef.current && dataTableRef.current.fetchData) {
			console.log("Clearing all filters with items per page:", itemsPerPage);
			// In email view mode, keep the kastKeys restriction even after clearing filters
			if (emailViewKastKeys.length > 0) {
				emptyFilters.kastKeys = emailViewKastKeys;
			}
			// Set flag to prevent useEffect from triggering duplicate fetch
			if (dataTableRef.current.setStateTriggerFlag) {
				dataTableRef.current.setStateTriggerFlag(true);
			}
			dataTableRef.current.fetchData(emptyFilters, 1, itemsPerPage);
		}
	}; // Handle VFF data export to CSV with S3 and modal
	const handleExportCSV = async () => {
		try {
			setIsExporting(true);
			// Prepare the current filters for export
			const exportFilters = {
				programm: selectedProgramm || [],
				project_number: selectedProjectNumber || [],
				fzg_nr: selectedFzgNr || [],
				bza: selectedBza || [],
				part_no: selectedPartNo || [],
				part_no_prefix: selectedPartNoPrefix || [],
				supplier: selectedSupplier || [],
				baukasten_no: selectedBaukastenNo || [],
				purchasing: selectedPurchasing || [],
				logistics1: selectedLogistics1 || [],
				logistics2: selectedLogistics2 || [],
				responsible_parts: selectedResponsibleParts || [],
				responsible_vehicle: selectedResponsibleVehicle || [],
				parts_status: selectedPartsStatus || [],
				vehicle_status: selectedVehicleStatus || [],
				statusColor: selectedAmpelTeilenanflug || [],
				statusBtt: selectedStatusBtt || [],
				kategorie_teilenanflug: selectedKategorieTeilenanflug || [],
				ruckmelde_stat: selectedRuckmeldeStat || [],
				alg: selectedAlg || [],
				se_team: selectedSeTeam || [],
				mb_key: selectedMbKey || [],
				tags: selectedTags || [],
				pet: selectedPet || { from: "", to: "" },
				changeNo: selectedChangeNo || [],
				kastKeyAnlage: selectedKastKeyAnlage || [],
				anlo: selectedAnlo || [],
				flagging: selectedFlagging || [],
				archive: selectedArchive || [],
				global_search: searchQuery || "",
				// Date range filters
				requirement_date_from: selectedRequirementDateFrom || null,
				vkgrArt: selectedVkgrArt || [],
				benenn: selectedBenenn || [],
				vkgr_bend: selectedVkgrBend || [],
				requirement_date_to: selectedRequirementDateTo || null,
				parts_followup_date_from: selectedPartsFollowupDateFrom || null,
				parts_followup_date_to: selectedPartsFollowupDateTo || null,
				ltb_date_from: selectedLtbDateFrom || null,
				ltb_date_to: selectedLtbDateTo || null,
			};

			console.log("🔄 Starting VFF export with filters:", exportFilters);

			// Count active filters for user feedback
			const activeFiltersCount = Object.values(exportFilters).reduce(
				(count, filterValue) => {
					if (Array.isArray(filterValue)) {
						return count + (filterValue.length > 0 ? 1 : 0);
					} else if (filterValue && typeof filterValue === "object") {
						// Handle object filters like pet: { from, to } or Date objects
						if (filterValue instanceof Date) {
							return count + 1;
						}
						const vals = Object.values(filterValue);
						return (
							count +
							(vals.some((v) => v !== null && v !== undefined && v !== "")
								? 1
								: 0)
						);
					} else {
						return (
							count +
							(filterValue &&
							typeof filterValue === "string" &&
							filterValue.trim()
								? 1
								: 0)
						);
					}
				},
				0,
			);

			console.log(
				`📊 Export will use ${activeFiltersCount > 0 ? `${activeFiltersCount} active filters (filtered data)` : "no filters (all data)"}`,
			);

			// Build query parameters for the export API
			const queryParams = new URLSearchParams();
			// Add array filters
			exportFilters.programm.forEach((p) => queryParams.append("programm", p));
			exportFilters.project_number.forEach((p) =>
				queryParams.append("project_number", p),
			);
			exportFilters.fzg_nr.forEach((f) => queryParams.append("fzg_nr", f));
			exportFilters.bza.forEach((b) => queryParams.append("bza", b));
			exportFilters.part_no.forEach((p) => queryParams.append("part_no", p));
			exportFilters.part_no_prefix.forEach((p) =>
				queryParams.append("part_no_prefix", p),
			);
			exportFilters.supplier.forEach((s) => queryParams.append("supplier", s));
			exportFilters.baukasten_no.forEach((b) =>
				queryParams.append("baukasten_no", b),
			);
			exportFilters.purchasing.forEach((p) =>
				queryParams.append("purchasing", p),
			);
			exportFilters.logistics1.forEach((l) =>
				queryParams.append("logistics1", l),
			);
			exportFilters.logistics2.forEach((l) =>
				queryParams.append("logistics2", l),
			);
			exportFilters.responsible_parts.forEach((r) =>
				queryParams.append("responsible_parts", r),
			);
			exportFilters.responsible_vehicle.forEach((r) =>
				queryParams.append("responsible_vehicle", r),
			);
			exportFilters.parts_status.forEach((p) =>
				queryParams.append("parts_status", p),
			);
			exportFilters.vehicle_status.forEach((v) =>
				queryParams.append("vehicle_status", v),
			);
			exportFilters.se_team.forEach((s) => queryParams.append("se_team", s));
			(exportFilters.mb_key || []).forEach((m) => queryParams.append("mb_key", m));
			(exportFilters.tags || []).forEach((t) => queryParams.append("tags", t));
			exportFilters.statusColor.forEach((a) =>
				queryParams.append("statusColor", a),
			);
			exportFilters.statusBtt.forEach((s) =>
				queryParams.append("statusBtt", s),
			);
			exportFilters.kategorie_teilenanflug.forEach((k) =>
				queryParams.append("kategorie_teilenanflug", k),
			);
			exportFilters.ruckmelde_stat.forEach((r) =>
				queryParams.append("ruckmelde_stat", r),
			);
			exportFilters.changeNo.forEach((c) => queryParams.append("change_no", c));
			exportFilters.kastKeyAnlage.forEach((k) =>
				queryParams.append("kast_key_anlage", k),
			);
			exportFilters.anlo.forEach((a) => queryParams.append("anlo", a));
			if (exportFilters.pet?.from)
				queryParams.append("pet_from", exportFilters.pet.from);
			if (exportFilters.pet?.to)
				queryParams.append("pet_to", exportFilters.pet.to);
			exportFilters.alg.forEach((a) => queryParams.append("alg", a));
			exportFilters.vkgrArt.forEach((a) => queryParams.append("vkgr_art", a));
			exportFilters.benenn.forEach((a) => queryParams.append("benenn", a));
			if (exportFilters.vkgr_bend) {
				exportFilters.vkgr_bend.forEach((a) => queryParams.append("vkgr_bend", a));
			}
			exportFilters.flagging.forEach((f) => queryParams.append("flagging", f));
			exportFilters.archive.forEach((a) => queryParams.append("archive", a));

			// Add date range filters if present
			if (exportFilters.requirement_date_from)
				queryParams.append(
					"requirement_date_from",
					exportFilters.requirement_date_from,
				);
			if (exportFilters.requirement_date_to)
				queryParams.append(
					"requirement_date_to",
					exportFilters.requirement_date_to,
				);
			if (exportFilters.parts_followup_date_from)
				queryParams.append(
					"parts_followup_date_from",
					exportFilters.parts_followup_date_from,
				);
			if (exportFilters.parts_followup_date_to)
				queryParams.append(
					"parts_followup_date_to",
					exportFilters.parts_followup_date_to,
				);
			if (exportFilters.ltb_date_from)
				queryParams.append("ltb_date_from", exportFilters.ltb_date_from);
			if (exportFilters.ltb_date_to)
				queryParams.append("ltb_date_to", exportFilters.ltb_date_to);

			// Add global search if present
			if (exportFilters.global_search) {
				queryParams.append("global_search", exportFilters.global_search);
			} // Use apiClient for proper authentication and CORS handling.
			// Export is a GET — strip X-User-Name so API Gateway's CORS preflight passes.
			console.log("📤 Calling S3 export API via apiClient...");

			const response = await apiClient.get(
				`/export-vff-csv?${queryParams.toString()}`,
				{
					headers: { "X-User-Name": undefined },
				},
			);

			// The response data should contain the export result
			const exportResult = response.data;

			if (exportResult.success && exportResult.download_url) {
				console.log("✅ Export successful:", exportResult);

				// Return the result to be handled by the modal
				return exportResult;
			} else {
				throw new Error(
					exportResult.message || "Export failed - no download URL received",
				);
			}
		} catch (error) {
			console.error("❌ Error exporting VFF data:", error);

			// Handle different error types for better user experience
			if (error.response) {
				// API returned an error response
				const errorMessage =
					error.response.data?.detail ||
					error.response.data?.message ||
					"Export failed";
				throw new Error(errorMessage);
			} else if (error.request) {
				// Request was made but no response received
				throw new Error(
					"Network error - please check your connection and try again",
				);
			} else {
				// Something else happened
				throw error;
			}
		} finally {
			setIsExporting(false);
		}
	}; // Handle opening export modal — now opens the background email-export modal
	const handleOpenExportModal = () => {
		setIsVFFExportEmailModalOpen(true);
	};

	// Handle closing export modal
	const handleCloseExportModal = () => {
		setIsVFFExportEmailModalOpen(false);
	}; // Handle opening database export modal
	const handleOpenDatabaseExportModal = () => {
		setIsDatabaseExportModalOpen(true);
	};
	// Handle closing database export modal
	const handleCloseDatabaseExportModal = () => {
		setIsDatabaseExportModalOpen(false);
	};

	// Handle opening reminder email modal
	const handleOpenReminderEmailModal = () => {
		if (!selectedItems || selectedItems.length === 0) {
			alert("Please select at least one record to send a reminder email.");
			return;
		}
		setIsReminderEmailModalOpen(true);
	};
	// Handle closing reminder email modal
	const handleCloseReminderEmailModal = () => {
		setIsReminderEmailModalOpen(false);
	};
	// Handle opening email history modal
	const handleOpenEmailHistoryModal = () => {
		setIsEmailHistoryModalOpen(true);
	};

	// Handle closing email history modal
	const handleCloseEmailHistoryModal = () => {
		setIsEmailHistoryModalOpen(false);
	};

	// Handle opening BOM history modal
	const handleOpenBOMHistoryModal = () => {
		setIsBOMHistoryModalOpen(true);
	};

	// Handle closing BOM history modal
	const handleCloseBOMHistoryModal = () => {
		setIsBOMHistoryModalOpen(false);
	};

	// Handle opening manual tracking modal
	const handleOpenManualTrackingModal = () => {
		setIsManualTrackingModalOpen(true);
	};

	// Handle closing manual tracking modal
	const handleCloseManualTrackingModal = () => {
		setIsManualTrackingModalOpen(false);
	};

	const BulkEditModal = ({ editOptions }) => {
		const [dropdownValues, setDropdownValues] = useState({
			projects: [],
			fzgNr: [],
			bza: [],
			supplier: [],
			total_req: [],
		});
		const [showItemSelector, setShowItemSelector] = useState(false);
		const [modalSelectedItems, setModalSelectedItems] = useState([
			...selectedItems,
		]);
		const [currentPageItems, setCurrentPageItems] = useState([]);
		const [loadingItems, setLoadingItems] = useState(false);
		const [error, setError] = useState(null);
		const isInitialMount = useRef(true);

		useEffect(() => {
			if (isBulkEditOpen && editOptions) {
				setDropdownValues({
					projects: editOptions.projects || [],
					fzgNr: editOptions.fzgNr || [],
					bza: editOptions.bza || [],
					supplier: editOptions.suppliers || [],
					total_req: editOptions.total_req || [],
				});

				// Only update modalSelectedItems on initial mount of the modal
				if (isInitialMount.current) {
					setModalSelectedItems([...selectedItems]);
					isInitialMount.current = false;
				}
			} else {
				// Reset the flag when modal is closed
				isInitialMount.current = true;
			}
		}, [isBulkEditOpen, editOptions]);

		useEffect(() => {
			const getCurrentItems = async () => {
				if (isBulkEditOpen && dataTableRef.current) {
					try {
						setLoadingItems(true);
						setError(null);
						let items = [];
						if (typeof dataTableRef.current.getCurrentPageData === "function") {
							items = dataTableRef.current.getCurrentPageData() || [];
							// Ensure each item has a consistent ID
							items = items.map((item) => ({
								...item,
								id: item.id || item.vehicle_no + item.part_no,
							}));
						} else {
							items = rows || [];
						}
						// Current page items available
						setCurrentPageItems(Array.isArray(items) ? items : []);
					} catch (error) {
						console.error(
							"Error getting current page items from VFFDataTable:",
							error,
						);
						setError(
							"Failed to load items from the current page. Please try again.",
						);
						setCurrentPageItems([]);
					} finally {
						setLoadingItems(false);
					}
				}
			};

			getCurrentItems();
		}, [isBulkEditOpen, rows]);

		const handleBulkEditChange = (field, value) => {
			setBulkEditValues((prev) => ({
				...prev,
				[field]: value,
			}));
		};

		const handleAddItems = () => {
			setShowItemSelector(!showItemSelector);
		};

		const handleModalSelectItem = (item) => {
			const itemId = item.vehicle_no + item.part_no; // Consistent ID
			const isSelected = modalSelectedItems.some(
				(selected) => selected.id === itemId,
			);
			let newModalSelectedItems;

			if (isSelected) {
				newModalSelectedItems = modalSelectedItems.filter(
					(selected) => selected.id !== itemId,
				);
			} else {
				newModalSelectedItems = [
					...modalSelectedItems,
					{ ...item, id: itemId },
				];
			}

			// Modal selected items updated
			setModalSelectedItems(newModalSelectedItems);
		};
		const handleSaveWithItems = async () => {
			try {
				const updates = Object.fromEntries(
					Object.entries(bulkEditValues).filter(([_, v]) => v !== ""),
				);

				if (Object.keys(updates).length === 0) {
					alert("Please make changes before saving");
					return;
				}

				if (modalSelectedItems.length === 0) {
					alert("No items selected for bulk edit");
					return;
				} // Handle archive bulk update
				if (
					updates.archive &&
					dataTableRef.current &&
					dataTableRef.current.handleBulkArchiveUpdate
				) {
					await dataTableRef.current.handleBulkArchiveUpdate(updates.archive);
				}

				// Handle other updates (excluding archive which is handled separately)
				const otherUpdates = Object.fromEntries(
					Object.entries(updates).filter(([key, _]) => key !== "archive"),
				);

				if (Object.keys(otherUpdates).length > 0) {
					const updatedItems = modalSelectedItems.map((item) => ({
						...item,
						...otherUpdates,
					}));

					await apiClient.post("/api/bulk-update", {
						ids: modalSelectedItems.map((item) => item.id),
						updates: otherUpdates,
					});

					setSelectedItems(updatedItems);
				}
				if (dataTableRef.current && dataTableRef.current.fetchData) {
					await dataTableRef.current.fetchData(
						{
							programm: selectedProgramm,
							fzgNr: selectedFzgNr,
							bza: selectedBza,
						},
						currentPage,
						itemsPerPage,
						selectedViewType,
					);
				}
				setBulkEditValues({
					programm: "",
					fzgNr: "",
					bza: "",
					supplier: "",
					total_req: "",
					archive: "",
				});
				handleCloseBulkEdit();
			} catch (error) {
				console.error("Error saving bulk edit:", error);
				alert(`Failed to save changes: ${error.message || "Unknown error"}`);
			}
		};

		if (!isBulkEditOpen) return null;

		return (
			<div style={{ ...styles.modal, ...fontStyles.regular }}>
				<div style={{ ...styles.modalContent }}>
					<div style={styles.modalHeader}>
						<h2
							style={{ ...styles.modalTitle, fontSize: "18px", color: "#333" }}
						>
							Bulk Edit ({modalSelectedItems.length} items selected)
						</h2>
						<button
							onClick={handleCloseBulkEdit}
							style={{
								background: "none",
								border: "none",
								fontSize: "30px",
								cursor: "pointer",
								color: "#666",
								padding: "5px 10px",
								borderRadius: "4px",
							}}
						>
							×
						</button>
					</div>
					<div style={styles.modalBody}>
						<div style={{ marginBottom: "20px" }}>
							<h3
								style={{
									margin: "0 0 15px 0",
									fontSize: "14px",
									color: "#444",
									fontWeight: "500",
								}}
							>
								Selected Items ({modalSelectedItems.length})
							</h3>
							{modalSelectedItems.length > 0 ? (
								<div
									style={{
										maxHeight: "300px",
										overflowY: "auto",
										border: "1px solid #eee",
										borderRadius: "4px",
									}}
								>
									<table style={{ ...styles.table, width: "100%" }}>
										<thead>
											<tr style={{ backgroundColor: "#f5f5f5" }}>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Vehicle No.
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Description
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Project
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Supplier
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													MET
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Required
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Munich
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Cracow
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Total Stock
												</th>
												<th
													style={{
														...styles.tableHeader,
														width: "40px",
														padding: "8px",
													}}
												>
													Fzg Nr
												</th>
												<th
													style={{
														...styles.tableHeader,
														width: "40px",
														padding: "8px",
													}}
												>
													BZA
												</th>
												<th
													style={{
														...styles.tableHeader,
														padding: "8px",
														textAlign: "left",
													}}
												>
													Action
												</th>
											</tr>
										</thead>
										<tbody>
											{modalSelectedItems.map((item, index) => (
												<tr
													key={`${item.id}-${index}`}
													style={{ borderBottom: "1px solid #eee" }}
												>
													<td style={{ ...styles.tableCell, fontSize: "12px" }}>
														{item.vehicle_no || "N/A"}
													</td>
													<td style={{ ...styles.tableCell, fontSize: "12px" }}>
														{item.part_description || "N/A"}
													</td>
													<td style={{ ...styles.tableCell, fontSize: "12px" }}>
														{item.project || "N/A"}
													</td>
													<td style={{ ...styles.tableCell, fontSize: "12px" }}>
														{item.supplier || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.met || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.required || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.munich || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.cracow || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.total_stock_mtb || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.fzg_nr || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														{item.bza || "N/A"}
													</td>
													<td
														style={{
															...styles.tableCell,
															padding: "10px",
															fontSize: "12px",
														}}
													>
														<button
															onClick={() => {
																setModalSelectedItems((prevItems) =>
																	prevItems.filter((_, i) => i !== index),
																);
															}}
															style={{
																background: "#cc0000",
																color: "white",
																border: "none",
																borderRadius: "4px",
																padding: "4px 8px",
																cursor: "pointer",
																fontSize: "12px",
																":hover": {
																	backgroundColor: "#990000",
																},
															}}
														>
															Remove
														</button>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							) : (
								<div
									style={{
										padding: "20px",
										textAlign: "center",
										color: "#666",
										backgroundColor: "#f9f9f9",
										border: "1px dashed #ddd",
										borderRadius: "4px",
									}}
								>
									No items selected. Use the table to select items for bulk
									edit.
								</div>
							)}
						</div>
						<div
							style={{
								marginBottom: "20px",
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
							}}
						>
							<h3
								style={{
									margin: 0,
									fontSize: "14px",
									color: "#444",
									fontWeight: "500",
								}}
							>
								Add More Items
							</h3>
							<button
								onClick={handleAddItems}
								style={{
									backgroundColor: "#666",
									color: "white",
									border: "none",
									padding: "8px 16px",
									cursor: "pointer",
									fontSize: "13px",
									borderRadius: "4px",
									display: "flex",
									alignItems: "center",
									gap: "6px",
								}}
							>
								{showItemSelector ? (
									<>
										<ChevronDown size={16} />
										Hide Item Selector
									</>
								) : (
									<>
										<Plus size={16} />
										Add Items from Current Page
									</>
								)}
							</button>
						</div>
						{showItemSelector && (
							<div
								style={{
									marginBottom: "20px",
									border: "1px solid #e0e0e0",
									borderRadius: "4px",
									overflow: "hidden",
									boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
								}}
							>
								<div
									style={{
										backgroundColor: "#666",
										padding: "10px 15px",
										borderBottom: "1px solid #e0e0e0",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<h4
										style={{
											margin: 0,
											fontSize: "13px",
											color: "white",
											fontWeight: "500",
										}}
									>
										Select Items from Current Page
									</h4>
									<div style={{ fontSize: "12px", color: "white" }}>
										{currentPageItems.length} items available
									</div>
								</div>

								<div style={{ maxHeight: "300px", overflowY: "auto" }}>
									{loadingItems ? (
										<Box display="flex" justifyContent="center" padding={4}>
											<CircularProgress size={24} sx={{ color: "#cc0000" }} />
										</Box>
									) : error ? (
										<Box padding={2} textAlign="center" color="#cc0000">
											{error}
										</Box>
									) : currentPageItems.length > 0 ? (
										<table
											style={{
												...styles.table,
												width: "100%",
												borderCollapse: "collapse",
											}}
										>
											<thead>
												<tr style={{ backgroundColor: "#f5f5f5" }}>
													<th
														style={{
															...styles.tableHeader,
															width: "40px",
															padding: "8px",
														}}
													></th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Vehicle No.
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Description
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Project
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Supplier
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														MET
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Required
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Munich
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Cracow
													</th>
													<th
														style={{
															...styles.tableHeader,
															padding: "8px",
															textAlign: "left",
														}}
													>
														Total Stock
													</th>
													<th
														style={{
															...styles.tableHeader,
															width: "40px",
															padding: "8px",
														}}
													>
														Fzg Nr
													</th>
													<th
														style={{
															...styles.tableHeader,
															width: "40px",
															padding: "8px",
														}}
													>
														BZA
													</th>
												</tr>
											</thead>
											<tbody>
												{currentPageItems.map((item, index) => {
													const itemId = item.vehicle_no + item.part_no;
													const isChecked = modalSelectedItems.some(
														(selected) => selected.id === itemId,
													);
													// Row selection updated
													return (
														<tr key={`${itemId}-${index}`}>
															<td
																style={{
																	...styles.tableCell,
																	textAlign: "center",
																}}
															>
																<input
																	type="checkbox"
																	checked={isChecked}
																	onChange={() => handleModalSelectItem(item)}
																	style={{ cursor: "pointer" }}
																/>
															</td>
															<td
																style={{
																	...styles.tableCell,
																	fontSize: "12px",
																}}
															>
																{item.vehicle_no || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	fontSize: "12px",
																}}
															>
																{item.part_description || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	fontSize: "12px",
																}}
															>
																{item.project || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	fontSize: "12px",
																}}
															>
																{item.supplier || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.met || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.required || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.munich || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.cracow || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.total_stock_mtb || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.fzg_nr || "N/A"}
															</td>
															<td
																style={{
																	...styles.tableCell,
																	padding: "10px",
																	fontSize: "12px",
																}}
															>
																{item.bza || "N/A"}
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									) : (
										<Box padding={2} textAlign="center" color="#666">
											No items found on the current page
										</Box>
									)}
								</div>
							</div>
						)}{" "}
						<div style={{ marginBottom: "20px" }}>
							<div
								style={{
									display: "grid",
									gridTemplateColumns: "1fr 1fr 1fr",
									gap: "15px",
								}}
							>
								{" "}
								<div>
									<label
										style={{
											display: "block",
											marginBottom: "8px",
											fontSize: "12px",
											color: "#666",
										}}
									>
										Programm
									</label>
									<select
										style={styles.select}
										value={bulkEditValues.programm || ""}
										onChange={(e) =>
											handleBulkEditChange("programm", e.target.value)
										}
									>
										<option value="">Keep existing</option>
										{(dropdownValues.projects || []).map((project) => (
											<option key={project} value={project}>
												{project}
											</option>
										))}
									</select>
								</div>
								<div>
									<label
										style={{
											display: "block",
											marginBottom: "8px",
											fontSize: "12px",
											color: "#666",
										}}
									>
										Fzg Nr
									</label>
									<select
										style={styles.select}
										value={bulkEditValues.fzgNr || ""}
										onChange={(e) =>
											handleBulkEditChange("fzgNr", e.target.value)
										}
									>
										<option value="">Keep existing</option>
										{(dropdownValues.fzgNr || []).map((fzg) => (
											<option key={fzg} value={fzg}>
												{fzg}
											</option>
										))}
									</select>
								</div>
								<div>
									<label
										style={{
											display: "block",
											marginBottom: "8px",
											fontSize: "12px",
											color: "#666",
										}}
									>
										BZA
									</label>
									<select
										style={styles.select}
										value={bulkEditValues.bza || ""}
										onChange={(e) =>
											handleBulkEditChange("bza", e.target.value)
										}
									>
										<option value="">Keep existing</option>
										{(dropdownValues.bza || []).map((bza) => (
											<option key={bza} value={bza}>
												{bza}
											</option>
										))}
									</select>{" "}
								</div>
								<div>
									<label
										style={{
											display: "block",
											marginBottom: "8px",
											fontSize: "12px",
											color: "#666",
										}}
									>
										Archive Status
									</label>
									<select
										style={styles.select}
										value={bulkEditValues.archive || ""}
										onChange={(e) =>
											handleBulkEditChange("archive", e.target.value)
										}
									>
										<option value="">Keep existing</option>
										<option value="N">N</option>
										<option value="To be deleted">To be deleted</option>
										<option value="Duplicate Entry">Duplicate Entry</option>
										<option value="No Demand">No Demand</option>
										<option value="Hausteile">Hausteile</option>
										<option value="On Hold">On Hold</option>
										<option value="PAT">PAT</option>
										<option value="Others">Others</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div style={styles.modalFooter}>
						<button
							onClick={handleCloseBulkEdit}
							style={{
								...styles.button,
								backgroundColor: "#fff",
								color: "#666",
								border: "1px solid #ddd",
							}}
						>
							Cancel
						</button>
						<button
							onClick={handleSaveWithItems}
							style={{ ...styles.button, backgroundColor: "#cc0000" }}
						>
							Save bulk edit
						</button>
					</div>
				</div>
			</div>
		);
	};
	return (
		<div style={styles.mainContainer}>
			{/* Loading overlay for dashboard filter application */}
			{isDashboardFilterLoading && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "rgba(0, 0, 0, 0.5)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 9999,
						flexDirection: "column",
					}}
				>
					<CircularProgress
						size={80}
						sx={{ color: "#1e2832", marginBottom: 2 }}
					/>
					<Typography
						variant="h6"
						sx={{
							color: "white",
							fontFamily: "MAN Europe_Bold",
							textAlign: "center",
							maxWidth: "300px",
						}}
					>
						Loading Parts Analysis Data...
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: "rgba(255, 255, 255, 0.8)",
							fontFamily: "MAN Europe_Regular",
							textAlign: "center",
							marginTop: 1,
						}}
					>
						Please wait while we load your parts data
					</Typography>{" "}
				</div>
			)}
			{/* Loading overlay for archived parts filter */}
			{isLoading && isArchivedPartsMode && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "rgba(0, 0, 0, 0.5)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 9999,
						flexDirection: "column",
					}}
				>
					<CircularProgress
						size={80}
						sx={{ color: "#cc0000", marginBottom: 2 }}
					/>
					<Typography
						variant="h6"
						sx={{
							color: "white",
							fontFamily: "MAN Europe_Bold",
							textAlign: "center",
							maxWidth: "300px",
						}}
					>
						Loading Archived Parts...
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: "rgba(255, 255, 255, 0.8)",
							fontFamily: "MAN Europe_Regular",
							textAlign: "center",
							marginTop: 1,
						}}
					>
						Filtering parts by archive status
					</Typography>
				</div>
			)}
			<Header user={user} signOut={signOut} onStartTour={handleStartTour} />{" "}
			<div
				style={{
					...styles.contentWrapper,
					paddingTop: emailViewKastKeys.length > 0 ? "38px" : undefined,
				}}
			>
				{" "}
				<VFFSidebar
					ref={sidebarRef}
					onFiltersChange={handleFiltersChange}
					onClearFilters={handleClearAllFilters}
					onColumnVisibilityChange={handleColumnVisibilityChange}
					columnVisibility={columnVisibility}
					selectedViewType={selectedViewType}
				/>
				<div style={styles.mainContent}>
					{/* Email View Mode Banner */}
					{emailViewKastKeys.length > 0 && (
						<div
							style={{
								position: "fixed",
								top: "74px",
								left: 0,
								right: 0,
								zIndex: 1200,
								backgroundColor: "#fff3cd",
								borderBottom: "2px solid #ffc107",
								padding: "8px 20px",
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								fontFamily: "MAN EUROPE_Regular, Arial, sans-serif",
								fontSize: "13px",
								color: "#856404",
							}}
						>
							<span
								style={{
									display: "flex",
									alignItems: "center",
									gap: "8px",
									fontFamily: "MAN EUROPE_Bold, Arial, sans-serif",
								}}
							>
								<img
									src="/mail.png"
									alt="Mail"
									style={{
										width: "18px",
										height: "18px",
										objectFit: "contain",
										flexShrink: 0,
									}}
								/>
								Email reminder view — showing {emailViewKastKeys.length} pinned
								record{emailViewKastKeys.length !== 1 ? "s" : ""} from the email
								link. Filters you apply will narrow down these records only.
							</span>
							<button
								onClick={handleExitEmailView}
								style={{
									background: "none",
									border: "1px solid #856404",
									borderRadius: "4px",
									padding: "3px 12px",
									cursor: "pointer",
									fontSize: "12px",
									color: "#856404",
									fontFamily: "MAN EUROPE_Bold, Arial, sans-serif",
									marginLeft: "16px",
									whiteSpace: "nowrap",
								}}
							>
								✕ Exit pinned view
							</button>
						</div>
					)}
					<div style={styles.searchContainer}>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								marginBottom: "-10px",
								padding: "0 40px",
							}}
						>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									width: "100%",
								}}
							>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										gap: "10px",
										marginTop: "-20px",
									}}
								>
									<Home size={20} color="#666" />
									<span
										style={{ color: "#666", fontFamily: "MAN Europe_Bold" }}
									>
										Home
									</span>
									<ChevronRight size={16} color="#666" />
									<span style={{ fontFamily: "MAN Europe_Bold" }}>
										Vehicle tracking
									</span>
								</div>{" "}
								<div
									style={{ display: "flex", gap: "10px", padding: "0 0 0 0" }}
								>
									{" "}
									{/* Edit Button */}
									<CraftButton
										purpose="standard"
										variant="secondary"
										size="s"
										type="button"
										onClick={() => setIsEditMode(!isEditMode)}
										title={isEditMode ? "Exit Edit Mode" : "Enter Edit Mode"}
									>
										<Edit2
											size={14}
											style={{ marginRight: "4px", verticalAlign: "middle" }}
										/>
										{isEditMode ? "Exit Edit" : "Edit"}
									</CraftButton>{" "}
									{/* Save Button - Only visible in edit mode */}
									{isEditMode && (
										<CraftButton
											purpose="standard"
											variant="secondary"
											size="s"
											type="button"
											onClick={handleBulkSave}
											disabled={
												Object.keys(editedItems).length === 0 || isSaving
											}
											loading={isSaving}
											title={
												Object.keys(editedItems).length === 0
													? "No changes to save"
													: `Save ${Object.keys(editedItems).length} changes`
											}
										>
											{!isSaving && (
												<Check
													size={14}
													style={{
														marginRight: "4px",
														verticalAlign: "middle",
													}}
												/>
											)}
											{isSaving
												? "Saving..."
												: `Save (${Object.keys(editedItems).length})`}
										</CraftButton>
									)}{" "}
									{/* Bulk Edit Button — red when active */}
									<div
										style={
											selectedItems &&
											selectedItems.length >= 1 &&
											selectedItems.length <= 100
												? {
														"--craft-cp-button-background-standard-primary-default":
															"#cc0000",
														"--craft-cp-button-background-standard-primary-hover":
															"#b30000",
														"--craft-cp-button-background-standard-primary-pressed":
															"#990000",
														"--craft-cp-button-border-standard-primary-default":
															"#cc0000",
														"--craft-cp-button-border-standard-primary-hover":
															"#b30000",
														"--craft-cp-button-text-standard-primary-default":
															"#ffffff",
														"--craft-cp-button-text-standard-primary-hover":
															"#ffffff",
													}
												: {}
										}
									>
										<CraftButton
											purpose="standard"
											variant="primary"
											size="s"
											type="button"
											onClick={handleOpenBulkEditModal}
											disabled={
												!selectedItems ||
												selectedItems.length < 1 ||
												selectedItems.length > 100
											}
											title={
												!selectedItems || selectedItems.length < 1
													? "Select at least 1 item to bulk edit"
													: selectedItems.length > 100
														? `Bulk edit is limited to 100 records. You have selected ${selectedItems.length}.`
														: `Bulk edit ${selectedItems.length} selected items`
											}
										>
											Bulk Edit
											{selectedItems && selectedItems.length > 0
												? ` (${selectedItems.length}${selectedItems.length > 100 ? " — max 100" : ""})`
												: ""}
										</CraftButton>
									</div>
									{/* Actions Dropdown */}
									<ActionsDropdownMenu
										selectedItems={selectedItems}
										isArchivedPartsMode={isArchivedPartsMode}
										isUserAuthorizedForDatabaseExport={
											isUserAuthorizedForDatabaseExport
										}
										onOpenReminderEmailModal={handleOpenReminderEmailModal}
										onOpenEmailHistoryModal={handleOpenEmailHistoryModal}
										onOpenBOMHistoryModal={handleOpenBOMHistoryModal}
										onOpenDatabaseExportModal={handleOpenDatabaseExportModal}
										onOpenManualTrackingModal={handleOpenManualTrackingModal}
										onArchivedPartsToggle={handleArchivedPartsToggle}
										onExportCSV={handleOpenExportModal}
									/>{" "}
									<div
										style={{
											"--craft-cp-button-background-standard-primary-default":
												"#cc0000",
											"--craft-cp-button-background-standard-primary-hover":
												"#b30000",
											"--craft-cp-button-background-standard-primary-pressed":
												"#990000",
											"--craft-cp-button-border-standard-primary-default":
												"#cc0000",
											"--craft-cp-button-border-standard-primary-hover":
												"#b30000",
										}}
									>
										<CraftButton
											purpose="standard"
											variant="primary"
											size="s"
											type="button"
											onClick={navigateToDashboard}
										>
											Dashboard
											<ChevronRight size={14} />
										</CraftButton>
									</div>
									{/* <button 
                    // onClick={handleBulkEdit}
                    style={{
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '4px 16px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      height: '36px',
                      fontFamily:'MAN Europe_Bold'
                    }}>
                  </button> */}
								</div>
							</div>
						</div>

						{/* Active Filters Display - Positioned exactly below Bulk Edit button, right-aligned */}
						<div
							style={{
								padding: "0px 40px 0px 0px",
								position: "relative",
								top: "25px",
								backgroundColor: "#f1f1f1",
							}}
						>
							{" "}
							<div
								style={{
									display: "flex",
									justifyContent: "flex-end",
									width: "100%",
								}}
							>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										gap: "10px",
										flexWrap: "wrap",
										position: "relative",
									}}
								>
									<span
										style={{
											fontSize: "14px",
											fontWeight: "bold",
											color: "#666",
											fontFamily: "MAN EUROPE_Bold",
										}}
									>
										Active Filters:
									</span>
									{(() => {
										const activeFilters = [];
										console.log(
											"📊 Active filters check - selectedSupplier state:",
											selectedSupplier,
										);

										// ...existing code to populate activeFilters...
										if (selectedProgramm && selectedProgramm.length > 0) {
											activeFilters.push({
												label: "Programm",
												values: selectedProgramm,
											});
										}
										if (
											selectedProjectNumber &&
											selectedProjectNumber.length > 0
										) {
											activeFilters.push({
												label: "Project Number",
												values: selectedProjectNumber,
											});
										}
										if (selectedPurchasing && selectedPurchasing.length > 0) {
											activeFilters.push({
												label: "Purchasing",
												values: selectedPurchasing,
											});
										}
										if (selectedLogistics1 && selectedLogistics1.length > 0) {
											activeFilters.push({
												label: "Logistics 1",
												values: selectedLogistics1,
											});
										}
										if (selectedLogistics2 && selectedLogistics2.length > 0) {
											activeFilters.push({
												label: "Logistics",
												values: selectedLogistics2,
											});
										}
										if (selectedFzgNr && selectedFzgNr.length > 0) {
											activeFilters.push({
												label: "Vehicle No",
												values: selectedFzgNr,
											});
										}
										if (selectedBza && selectedBza.length > 0) {
											activeFilters.push({ label: "BZA", values: selectedBza });
										}
										if (selectedPartNo && selectedPartNo.length > 0) {
											activeFilters.push({
												label: "Part Number",
												values: selectedPartNo,
											});
										}
										if (
											selectedPartNoPrefix &&
											selectedPartNoPrefix.length > 0
										) {
											activeFilters.push({
												label: "Part Number Prefix",
												values: selectedPartNoPrefix,
											});
										}
										if (selectedSupplier && selectedSupplier.length > 0) {
											console.log(
												"📊 Adding supplier to active filters:",
												selectedSupplier,
											);
											activeFilters.push({
												label: "Supplier",
												values: selectedSupplier,
											});
										}
										if (selectedBaukastenNo && selectedBaukastenNo.length > 0) {
											activeFilters.push({
												label: "Baukasten Number",
												values: selectedBaukastenNo,
											});
										}
										if (
											selectedResponsibleParts &&
											selectedResponsibleParts.length > 0
										) {
											activeFilters.push({
												label: "Responsible Parts",
												values: selectedResponsibleParts,
											});
										}
										if (
											selectedResponsibleVehicle &&
											selectedResponsibleVehicle.length > 0
										) {
											activeFilters.push({
												label: "Responsible Vehicle",
												values: selectedResponsibleVehicle,
											});
										}
										if (selectedPartsStatus && selectedPartsStatus.length > 0) {
											activeFilters.push({
												label: "Parts Status",
												values: selectedPartsStatus,
											});
										}
										if (
											selectedVehicleStatus &&
											selectedVehicleStatus.length > 0
										) {
											activeFilters.push({
												label: "Vehicle Status",
												values: selectedVehicleStatus,
											});
										}
										if (
											selectedAmpelTeilenanflug &&
											selectedAmpelTeilenanflug.length > 0
										) {
											activeFilters.push({
												label: "Ampel Teilenanflug",
												values: selectedAmpelTeilenanflug,
											});
										}
										if (selectedStatusBtt && selectedStatusBtt.length > 0) {
											activeFilters.push({
												label: "Status BTT",
												values: selectedStatusBtt,
											});
										}
										if (
											selectedKategorieTeilenanflug &&
											selectedKategorieTeilenanflug.length > 0
										) {
											activeFilters.push({
												label: "Kategorie Teilenanflug",
												values: selectedKategorieTeilenanflug,
											});
										}
										if (
											selectedRuckmeldeStat &&
											selectedRuckmeldeStat.length > 0
										) {
											activeFilters.push({
												label: "Rückmelde Status",
												values: selectedRuckmeldeStat,
											});
										}
										if (selectedAlg && selectedAlg.length > 0) {
											activeFilters.push({ label: "ALG", values: selectedAlg });
										}
										if (selectedPet && (selectedPet.from || selectedPet.to)) {
											const petRange = [];
											if (selectedPet.from)
												petRange.push(`From: ${selectedPet.from}`);
											if (selectedPet.to)
												petRange.push(`To: ${selectedPet.to}`);
											activeFilters.push({ label: "PET", values: petRange });
										}
										if (selectedChangeNo && selectedChangeNo.length > 0) {
											activeFilters.push({
												label: "Change Number",
												values: selectedChangeNo,
											});
										}
										if (
											selectedKastKeyAnlage &&
											selectedKastKeyAnlage.length > 0
										) {
											activeFilters.push({
												label: "KAST Key Anlage",
												values: selectedKastKeyAnlage,
											});
										}
										if (selectedAnlo && selectedAnlo.length > 0) {
											activeFilters.push({
												label: "ANLO",
												values: selectedAnlo,
											});
										}
										if (selectedVkgrArt && selectedVkgrArt.length > 0) {
											activeFilters.push({
												label: "VKGR Art",
												values: selectedVkgrArt,
											});
										}
										if (selectedBenenn && selectedBenenn.length > 0) {
											activeFilters.push({
												label: "Benenn",
												values: selectedBenenn,
											});
										}
										if (selectedVkgrBend && selectedVkgrBend.length > 0) {
											activeFilters.push({
												label: "VKGR Bend",
												values: selectedVkgrBend,
											});
										}
										if (selectedSeTeam && selectedSeTeam.length > 0) {
											activeFilters.push({
												label: "SE Team",
												values: selectedSeTeam,
											});
										}
										if (selectedMbKey && selectedMbKey.length > 0) {
											activeFilters.push({
												label: "MB Key",
												values: selectedMbKey,
											});
										}
										if (selectedTags && selectedTags.length > 0) {
											activeFilters.push({
												label: "Tags",
												values: selectedTags,
											});
										}
										if (selectedFlagging && selectedFlagging.length > 0) {
											activeFilters.push({
												label: "Flagging",
												values: selectedFlagging,
											});
										}
										if (selectedArchive && selectedArchive.length > 0) {
											activeFilters.push({
												label: "Archive",
												values: selectedArchive,
											});
										}
										if (
											selectedRequirementDateFrom ||
											selectedRequirementDateTo
										) {
											const dateRange = [];
											if (selectedRequirementDateFrom)
												dateRange.push(`From: ${selectedRequirementDateFrom}`);
											if (selectedRequirementDateTo)
												dateRange.push(`To: ${selectedRequirementDateTo}`);
											activeFilters.push({
												label: "Requirement Date",
												values: dateRange,
											});
										}
										if (
											selectedPartsFollowupDateFrom ||
											selectedPartsFollowupDateTo
										) {
											const dateRange = [];
											if (selectedPartsFollowupDateFrom)
												dateRange.push(
													`From: ${selectedPartsFollowupDateFrom}`,
												);
											if (selectedPartsFollowupDateTo)
												dateRange.push(`To: ${selectedPartsFollowupDateTo}`);
											activeFilters.push({
												label: "Parts Followup Date",
												values: dateRange,
											});
										}
										if (selectedLtbDateFrom || selectedLtbDateTo) {
											const dateRange = [];
											if (selectedLtbDateFrom)
												dateRange.push(`From: ${selectedLtbDateFrom}`);
											if (selectedLtbDateTo)
												dateRange.push(`To: ${selectedLtbDateTo}`);
											activeFilters.push({
												label: "LTB Date",
												values: dateRange,
											});
										}
										if (searchQuery && searchQuery.trim()) {
											activeFilters.push({
												label: "Search",
												values: [searchQuery],
											});
										}

										const totalActiveFilters = activeFilters.reduce(
											(sum, filter) => sum + filter.values.length,
											0,
										);

										// Only show first filter group, and limit to 3 values
										const displayFilter =
											activeFilters.length > 0 ? activeFilters[0] : null;
										const hiddenFiltersCount = activeFilters
											.slice(1)
											.reduce((sum, filter) => sum + filter.values.length, 0);
										const hiddenValuesInFirstFilter =
											displayFilter && displayFilter.values.length > 3
												? displayFilter.values.length - 3
												: 0;
										const totalHiddenCount =
											hiddenFiltersCount + hiddenValuesInFirstFilter;

										return activeFilters.length > 0 ? (
											<>
												<span
													style={{
														fontSize: "12px",
														color: "#999",
														fontFamily: "MAN EUROPE_Regular",
													}}
												>
													({totalActiveFilters} total)
												</span>
												<div
													style={{
														display: "flex",
														gap: "8px",
														flexWrap: "wrap",
														alignItems: "center",
													}}
												>
													{displayFilter &&
														displayFilter.values.length <= 3 && (
															<div
																style={{
																	display: "flex",
																	alignItems: "center",
																	gap: "4px",
																}}
															>
																<span
																	style={{
																		fontSize: "11px",
																		fontWeight: "bold",
																		color: "#cc0000",
																		fontFamily: "MAN EUROPE_Regular",
																	}}
																>
																	{displayFilter.label}:
																</span>
																<div
																	style={{
																		display: "flex",
																		gap: "2px",
																		flexWrap: "wrap",
																	}}
																>
																	{displayFilter.values.map(
																		(value, valueIndex) => (
																			<span
																				key={valueIndex}
																				style={{
																					display: "inline-block",
																					backgroundColor: "#cc0000",
																					color: "white",
																					padding: "2px 6px",
																					borderRadius: "10px",
																					fontSize: "10px",
																					fontFamily: "MAN EUROPE_Regular",
																				}}
																			>
																				{value}
																			</span>
																		),
																	)}
																</div>
															</div>
														)}{" "}
													{totalHiddenCount > 0 && (
														<button
															onClick={() =>
																setShowFilterTooltip(!showFilterTooltip)
															}
															style={{
																display: "inline-flex",
																alignItems: "center",
																gap: "4px",
																backgroundColor: "#666",
																color: "white",
																padding: "4px 10px",
																borderRadius: "12px",
																fontSize: "11px",
																fontFamily: "MAN EUROPE_Regular",
																cursor: "pointer",
																border: "none",
																transition: "background-color 0.2s",
																whiteSpace: "nowrap",
															}}
															onMouseEnter={(e) =>
																(e.target.style.backgroundColor = "#555")
															}
															onMouseLeave={(e) =>
																(e.target.style.backgroundColor = "#666")
															}
														>
															Show more filters ({totalHiddenCount})
														</button>
													)}
												</div>

												{/* Tooltip with close button */}
												{showFilterTooltip && (
													<div
														style={{
															position: "absolute",
															top: "100%",
															right: "0",
															marginTop: "8px",
															backgroundColor: "white",
															border: "1px solid #ddd",
															borderRadius: "8px",
															padding: "12px",
															boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
															zIndex: 1000,
															minWidth: "300px",
															maxWidth: "500px",
															maxHeight: "400px",
															overflowY: "auto",
														}}
													>
														<div
															style={{
																display: "flex",
																justifyContent: "space-between",
																alignItems: "center",
																marginBottom: "8px",
															}}
														>
															<div
																style={{
																	fontSize: "12px",
																	fontWeight: "bold",
																	color: "#333",
																	fontFamily: "MAN EUROPE_Bold",
																}}
															>
																All Active Filters
															</div>
															<button
																onClick={() => setShowFilterTooltip(false)}
																style={{
																	background: "none",
																	border: "none",
																	fontSize: "20px",
																	cursor: "pointer",
																	color: "#666",
																	padding: "0",
																	lineHeight: "1",
																	width: "20px",
																	height: "20px",
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "center",
																}}
																aria-label="Close"
															>
																×
															</button>
														</div>
														{activeFilters.map((filter, index) => (
															<div
																key={index}
																style={{
																	marginBottom: "8px",
																	paddingBottom: "8px",
																	borderBottom:
																		index < activeFilters.length - 1
																			? "1px solid #eee"
																			: "none",
																}}
															>
																<div
																	style={{
																		fontSize: "11px",
																		fontWeight: "bold",
																		color: "#cc0000",
																		marginBottom: "4px",
																		fontFamily: "MAN EUROPE_Bold",
																	}}
																>
																	{filter.label}:
																</div>
																<div
																	style={{
																		display: "flex",
																		gap: "4px",
																		flexWrap: "wrap",
																	}}
																>
																	{filter.values.map((value, valueIndex) => (
																		<span
																			key={valueIndex}
																			style={{
																				display: "inline-block",
																				backgroundColor: "#cc0000",
																				color: "white",
																				padding: "2px 6px",
																				borderRadius: "10px",
																				fontSize: "10px",
																				fontFamily: "MAN EUROPE_Regular",
																			}}
																		>
																			{value}
																		</span>
																	))}
																</div>
															</div>
														))}
													</div>
												)}
											</>
										) : (
											<span
												style={{
													fontSize: "12px",
													color: "#999",
													fontFamily: "MAN EUROPE_Regular",
												}}
											>
												No active filters
											</span>
										);
									})()}
								</div>
							</div>
						</div>

						<div
							style={{
								display: "flex",
								alignItems: "center",
								marginBottom: "5px",
								marginTop: "-15px",
								padding: "0 40px",
							}}
						>
							<form
								onSubmit={handleSearchSubmit}
								style={{
									flex: 1,
									position: "relative",
									maxWidth: "600px",
									display: "flex",
									gap: "8px",
								}}
							>
								<div style={{ position: "relative", flex: 1 }}>
									<input
										type="text"
										data-tour-target="vff-search-bar"
										placeholder="Search for Vehicle No & Part No"
										value={searchInput}
										onChange={(e) => setSearchInput(e.target.value)}
										onKeyDown={(e) =>
											e.key === "Enter" && handleSearchSubmit(e)
										}
										style={{
											width: "100%",
											padding: "10px 40px 10px 40px",
											border: "1px solid #ddd",
											borderRadius: "4px",
											fontSize: "12px",
											boxSizing: "border-box",
											boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
										}}
									/>
									<Search
										style={{
											position: "absolute",
											left: "12px",
											top: "50%",
											transform: "translateY(-50%)",
											color: "#666",
											width: "16px",
											height: "16px",
											pointerEvents: "none",
										}}
									/>
									{searchInput && (
										<button
											type="button"
											onClick={handleSearchClear}
											style={{
												position: "absolute",
												right: "12px",
												top: "50%",
												transform: "translateY(-50%)",
												background: "none",
												border: "none",
												color: "#999",
												cursor: "pointer",
												padding: "4px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}
											aria-label="Clear search"
										>
											×
										</button>
									)}
								</div>
								<button
									type="submit"
									style={{
										padding: "10px 20px",
										backgroundColor: "#1e2832",
										fontFamily: "MAN EUROPE_Bold",
										color: "white",
										border: "none",
										cursor: "pointer",
										fontSize: "14px",
										fontWeight: "bold",
										whiteSpace: "nowrap",
										transition: "background-color 0.2s",
									}}
								>
									{" "}
									Search
								</button>
							</form>
						</div>
					</div>
					<div style={styles.tableContainer}>
						<VFFDataTable
							ref={dataTableRef}
							rows={rows}
							totalRecords={totalRecords}
							fetchData={handlePageChange}
							onSelectItems={handleSelectItems}
							onUpdateItem={handleUpdateItem}
							selectedItems={selectedItems}
							editOptions={editOptions}
							columnVisibility={columnVisibility}
							selectedViewType={selectedViewType}
							getUserDisplayName={getUserDisplayName}
							getUserEmail={getUserEmail}
							isEditMode={isEditMode}
							editedItems={editedItems}
							onEditedItemsChange={setEditedItems}
						/>
					</div>{" "}
				</div>{" "}
			</div>{" "}
			{/* VFF Bulk Edit Modal */}{" "}
			<VFFBulkEditModal
				open={isBulkEditModalOpen}
				onClose={handleCloseBulkEditModal}
				selectedItems={selectedItemsForBulkEdit}
				onSave={handleBulkEditSave}
				isSaving={isSaving}
				processingProgress={processingProgress}
				getUserDisplayName={getUserDisplayName}
			/>{" "}
			{/* VFF Email Export Modal (background fire-and-forget) */}{" "}
			<VFFExportEmailModal
				isOpen={isVFFExportEmailModalOpen}
				onClose={handleCloseExportModal}
				userEmail={getUserEmail()}
				emailViewKastKeys={emailViewKastKeys}
				exportFilters={{
					programm: selectedProgramm,
					project_number: selectedProjectNumber,
					fzg_nr: selectedFzgNr,
					bza: selectedBza,
					part_no: selectedPartNo,
					part_no_prefix: selectedPartNoPrefix,
					supplier: selectedSupplier,
					baukasten_no: selectedBaukastenNo,
					purchasing: selectedPurchasing,
					logistics1: selectedLogistics1,
					logistics2: selectedLogistics2,
					responsible_parts: selectedResponsibleParts,
					responsible_vehicle: selectedResponsibleVehicle,
					parts_status: selectedPartsStatus,
					vehicle_status: selectedVehicleStatus,
					statusColor: selectedAmpelTeilenanflug,
					statusBtt: selectedStatusBtt,
					kategorie_teilenanflug: selectedKategorieTeilenanflug,
					ruckmelde_stat: selectedRuckmeldeStat,
					alg: selectedAlg,
					pet: selectedPet,
					se_team: selectedSeTeam,
					change_no: selectedChangeNo,
					kast_key_anlage: selectedKastKeyAnlage,
					anlo: selectedAnlo,
					vkgr_art: selectedVkgrArt,
					benenn: selectedBenenn,
					vkgr_bend: selectedVkgrBend,
					mb_key: selectedMbKey,
					tags: selectedTags,
					flagging: selectedFlagging,
					archive: selectedArchive,
					global_search: searchQuery,
					requirement_date_from: selectedRequirementDateFrom,
					requirement_date_to: selectedRequirementDateTo,
					parts_followup_date_from: selectedPartsFollowupDateFrom,
					parts_followup_date_to: selectedPartsFollowupDateTo,
					ltb_date_from: selectedLtbDateFrom,
					ltb_date_to: selectedLtbDateTo,
				}}
			/>
			{/* Database Export Modal - Only available to authorized users */}
			{isUserAuthorizedForDatabaseExport && (
				<DatabaseExportModal
					isOpen={isDatabaseExportModalOpen}
					onClose={handleCloseDatabaseExportModal}
					userEmail={getUserEmail()}
				/>
			)}{" "}
			{/* Reminder Email Modal */}
			<ReminderEmailModal
				open={isReminderEmailModalOpen}
				onClose={handleCloseReminderEmailModal}
				selectedRecords={selectedItems}
				fromEmail={getUserEmail()}
				getUserDisplayName={getUserDisplayName}
			/>{" "}
			{/* Email History Modal */}
			<EmailHistoryModal
				open={isEmailHistoryModalOpen}
				onClose={handleCloseEmailHistoryModal}
				fromEmail={getUserEmail()}
			/>
			{/* BOM History Modal */}
			<BOMHistoryModal
				isOpen={isBOMHistoryModalOpen}
				onClose={handleCloseBOMHistoryModal}
			/>{" "}
			{/* Manual Tracking Modal */}
			<ManualTrackingModal
				open={isManualTrackingModalOpen}
				onClose={handleCloseManualTrackingModal}
			/>
			{/* VFF Tour */}
			<VFFJoyrideTour isOpen={isTourOpen} onClose={handleCloseTour} />
		</div>
	);
};

// Actions Dropdown Menu Component
const ActionsDropdownMenu = ({
	selectedItems,
	isArchivedPartsMode,
	isUserAuthorizedForDatabaseExport,
	onOpenReminderEmailModal,
	onOpenEmailHistoryModal,
	onOpenBOMHistoryModal,
	onOpenDatabaseExportModal,
	onOpenManualTrackingModal,
	onArchivedPartsToggle,
	onExportCSV,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleItemClick = (callback) => {
		callback();
		setIsOpen(false);
	};

	return (
		<div style={{ position: "relative" }} ref={dropdownRef}>
			<CraftButton
				purpose="standard"
				variant="secondary"
				size="s"
				type="button"
				onClick={() => setIsOpen(!isOpen)}
			>
				<span>Actions</span>
				<ChevronDown
					size={14}
					style={{
						transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
						transition: "transform 0.2s ease",
					}}
				/>
			</CraftButton>

			{isOpen && (
				<div
					style={{
						position: "absolute",
						top: "100%",
						right: 0,
						backgroundColor: "white",
						border: "1px solid #ddd",
						borderRadius: "6px",
						boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
						zIndex: 1000,
						minWidth: "200px",
						marginTop: "4px",
					}}
				>
					{/* Reminder Email */}
					<button
						onClick={() => handleItemClick(onOpenReminderEmailModal)}
						disabled={!selectedItems || selectedItems.length === 0}
						style={{
							width: "100%",
							padding: "12px 16px",
							backgroundColor: "transparent",
							border: "none",
							textAlign: "left",
							cursor:
								!selectedItems || selectedItems.length === 0
									? "not-allowed"
									: "pointer",
							fontSize: "14px",
							color:
								!selectedItems || selectedItems.length === 0 ? "#999" : "#333",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							transition: "background-color 0.2s",
							borderBottom: "1px solid #f8f8f8",
						}}
						onMouseEnter={(e) => {
							if (selectedItems && selectedItems.length > 0) {
								e.target.style.backgroundColor = "#f8f9fa";
							}
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = "transparent";
						}}
						title={
							!selectedItems || selectedItems.length === 0
								? "Select at least one record to send reminder email"
								: "Send reminder email for selected records"
						}
					>
						<Mail size={16} />
						<span>Reminder Email</span>
						{selectedItems && selectedItems.length > 0 && (
							<span
								style={{
									marginLeft: "auto",
									fontSize: "12px",
									color: "#666",
									backgroundColor: "#e3f2fd",
									padding: "2px 6px",
									borderRadius: "10px",
								}}
							>
								{selectedItems.length}
							</span>
						)}
					</button>{" "}
					{/* Email History */}
					<button
						onClick={() => handleItemClick(onOpenEmailHistoryModal)}
						style={{
							width: "100%",
							padding: "12px 16px",
							backgroundColor: "transparent",
							border: "none",
							textAlign: "left",
							cursor: "pointer",
							fontSize: "14px",
							color: "#333",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							transition: "background-color 0.2s",
							borderBottom: "1px solid #f8f8f8",
						}}
						onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
						onMouseLeave={(e) =>
							(e.target.style.backgroundColor = "transparent")
						}
					>
						<History size={16} />
						<span>Email History</span>{" "}
					</button>{" "}
					{/* BOM History - Disabled */}
					<button
						// onClick={() => handleItemClick(onOpenBOMHistoryModal)}
						style={{
							width: "100%",
							padding: "12px 16px",
							backgroundColor: "transparent",
							border: "none",
							textAlign: "left",
							// cursor: 'not-allowed',
							fontSize: "14px",
							color: "#999",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							transition: "background-color 0.2s",
							borderBottom: "1px solid #f8f8f8",
							opacity: "0.5",
						}}
					>
						<FolderOpen size={16} />
						BOM History (Coming Soon)
					</button>{" "}
					{/* Manual Tracking - Disabled */}
					<button
						// onClick={() => handleItemClick(onOpenManualTrackingModal)}
						style={{
							width: "100%",
							padding: "12px 16px",
							backgroundColor: "transparent",
							border: "none",
							textAlign: "left",
							// cursor: 'not-allowed',
							fontSize: "14px",
							color: "#999",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							transition: "background-color 0.2s",
							borderBottom: "1px solid #f8f8f8",
							opacity: "0.5",
						}}
					>
						<FileText size={16} />
						Manual Tracking (Coming Soon)
					</button>
					{/* Database Export (only for authorized users) */}
					{isUserAuthorizedForDatabaseExport && (
						<button
							onClick={() => handleItemClick(onOpenDatabaseExportModal)}
							style={{
								width: "100%",
								padding: "12px 16px",
								backgroundColor: "transparent",
								border: "none",
								textAlign: "left",
								cursor: "pointer",
								fontSize: "14px",
								color: "#333",
								display: "flex",
								alignItems: "center",
								gap: "10px",
								transition: "background-color 0.2s",
								borderBottom: "1px solid #f8f8f8",
							}}
							onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
							onMouseLeave={(e) =>
								(e.target.style.backgroundColor = "transparent")
							}
						>
							<HardDrive size={16} />
							<span>Database Export</span>
						</button>
					)}
					{/* Archived Parts Toggle */}
					<button
						onClick={() => handleItemClick(onArchivedPartsToggle)}
						style={{
							width: "100%",
							padding: "12px 16px",
							backgroundColor: "transparent",
							border: "none",
							textAlign: "left",
							cursor: "pointer",
							fontSize: "14px",
							color: "#333",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							transition: "background-color 0.2s",
							borderBottom: "1px solid #f8f8f8",
						}}
						onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
						onMouseLeave={(e) =>
							(e.target.style.backgroundColor = "transparent")
						}
					>
						<Archive size={16} />
						<span>
							{isArchivedPartsMode
								? "Exit Archived Mode"
								: "View Archived Parts"}
						</span>
						{isArchivedPartsMode && (
							<span
								style={{
									marginLeft: "auto",
									fontSize: "10px",
									color: "#white",
									backgroundColor: "#ff9800",
									padding: "2px 6px",
									borderRadius: "10px",
									fontWeight: "bold",
								}}
							>
								ACTIVE
							</span>
						)}
					</button>
					{/* Export CSV */}
					<button
						onClick={() => handleItemClick(onExportCSV)}
						style={{
							width: "100%",
							padding: "12px 16px",
							backgroundColor: "transparent",
							border: "none",
							textAlign: "left",
							cursor: "pointer",
							fontSize: "14px",
							color: "#333",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							transition: "background-color 0.2s",
							borderTopLeftRadius: "0",
							borderTopRightRadius: "0",
							borderBottomLeftRadius: "6px",
							borderBottomRightRadius: "6px",
						}}
						onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
						onMouseLeave={(e) =>
							(e.target.style.backgroundColor = "transparent")
						}
					>
						<Download size={16} />
						<span>Export CSV</span>
					</button>
				</div>
			)}
		</div>
	);
};

export default VFFPage;
